import { getDeviceModelsV1 } from '@ingenico/api-sdk-assets-public';
import {
  DynamicGroupListBffResponseApi,
  getDynamicGroupByIdBffV1,
  getSmartFieldByIdBffV1,
  searchDynamicGroupsBffV1,
  SearchDynamicGroupsBffV1MutationRequestApi,
  SearchDynamicGroupsBffV1QueryParamsApi,
  searchSmartFieldsBffV1,
  SearchSmartFieldsBffV1MutationRequestApi,
  SearchSmartFieldsBffV1QueryParamsApi,
} from '@ingenico/api-sdk-configuration-private';
import type { CategoryResourceReadApi } from '@ingenico/api-sdk-configuration-public';
import {
  SearchRequestApi as ConfigurationSearchRequestApi,
  createCategoryV1,
  CreateCategoryV1MutationRequestApi,
  createSmartFieldV1,
  CreateSmartFieldV1MutationRequestApi,
  searchCategoriesV1,
  SearchCategoriesV1QueryParamsApi,
} from '@ingenico/api-sdk-configuration-public';
import type { CoreClient } from '@ingenico/api-sdk-core/common';
import {
  CallStatusResourceResponseListResponseApi,
  deleteConfigurationByIdV1,
  DeleteConfigurationByIdV1MutationResponseApi,
  getDeviceConnectionStatusByDeviceIdV1,
  OrganizationResourceListResponseApi,
} from '@ingenico/api-sdk-device-management-private';
import {
  ApplicationResourceReadV2Api,
  ApplicationResourceWriteV2Api,
  ApplicationVersionResourceListResponseV2Api,
  ApplicationVersionResourceReadV2Api,
  CatalogShareResourceReadApi,
  ConfigurationModuleResourceReadBffV2Api,
  ConfigurationResourceReadV2Api,
  ConfigurationResourceRemoteKeyInjectionBasicApi,
  ConfigurationResourceSnapshotReadBffV2Api,
  createActionOnDeploymentRequestByIdV2,
  createCancelDeviceLogSessionV2,
  createApplicationV2,
  createApplicationVersionV2,
  CreateApplicationVersionV2MutationRequestApi,
  createArtifactV2,
  CreateArtifactV2QueryParamsApi,
  createCatalogShareV2,
  createConfigurationModuleV2,
  CreateConfigurationModuleV2MutationRequestApi,
  CreateConfigurationModuleV2MutationResponseApi,
  createConfigurationV2,
  CreateConfigurationV2MutationRequestApi,
  CreateConfigurationV2MutationResponseApi,
  createDeploymentRequestV2,
  createDeviceLogSessionV2,
  CreateDeviceLogSessionV2MutationRequestApi,
  createOsV2,
  CreateOsV2MutationRequestApi,
  createOsVersionV2,
  CreateOsVersionV2MutationRequestApi,
  createParameterSetV2,
  CreateParameterSetV2MutationRequestApi,
  createResourceV2,
  CreateResourceV2MutationRequestApi,
  createRkiConfigurationByOrganizationIdV2,
  CreateRkiConfigurationByOrganizationIdV2MutationRequestApi,
  createSystemPackageV2,
  CreateSystemPackageV2MutationRequestApi,
  createSystemPackageVersionV2,
  CreateSystemPackageVersionV2MutationRequestApi,
  createStopDeviceLogSessionV2,
  CreateStopDeviceLogSessionV2MutationRequestApi,
  createTemplateV2,
  createUpdateActionMetricsByDeviceIdV2,
  deleteConfigurationByIdV2,
  deleteConfigurationModuleByIdV2,
  deleteEnvironmentByOrganizationIdV2,
  deleteResourceByIdV2,
  DeviceLogResourceListResponseApi,
  DeviceResourceDiagnosticsListResponseApi,
  downloadAssetByIdV2,
  downloadDeviceLogFileByIdV2,
  downloadOutputFileForTemplateV2,
  downloadOutputFileV2,
  enumMonitoringLevels,
  getAllEnvironmentsV2,
  getAllOsVersionArtifactsByOsVersionIdV2,
  getAllSystemPackageArtifactsBySystemPackageIdV2,
  getAllSystemPackageVersionArtifactsBySystemPackageVersionIdV2,
  getApplicationArtifactsByApplicationIdV2,
  getApplicationByIdV2,
  getApplicationOrganizationsByApplicationIdV2,
  GetApplicationOrganizationsByApplicationIdV2QueryParamsApi,
  getApplicationTemplatesByApplicationIdV2,
  getApplicationVersionArtifactByApplicationVersionIdV2,
  getApplicationVersionTemplatesByApplicationVersionIdV2,
  getBffApplicationVersionByIdV2,
  getBffSystemPackageVersionByIdV2,
  getArtifactCapabilitiesV2,
  getCatalogShareByIdBffV2,
  getConfigurationByIdBffV2,
  getConfigurationByIdV2,
  getConfigurationModuleByIdBffV2,
  getConfigurationModuleSearchFieldsV2,
  getConfigurationModuleSnapshotByIdBffV2,
  getConfigurationSnapshotByIdBffV2,
  getDeploymentRequestByIdBffV2,
  getDeploymentUnitByIdBffV2,
  getDeviceAlertsV2,
  getDeviceCallByIdV2,
  getDeviceDiagnosticByDeviceIdAndDiagnosticIdV2,
  GetDeviceDiagnosticByDeviceIdAndDiagnosticIdV2QueryResponseApi,
  getDeviceMetricsByDeviceIdV2,
  getDeviceSoftwaresByDeviceIdV2,
  getEnvironmentByOrganizationIdV2,
  getKeySetReferenceV2,
  getOrganizationKeySetsV2,
  getOsAssetsByOsIdV2,
  getOsAuthorizedOrganizationsByOsIdV2,
  GetOsAuthorizedOrganizationsByOsIdV2QueryParamsApi,
  getOsByIdV2,
  getOsVersionByIdV2,
  getOutputFilenamesForDeploymentUnitV2,
  getParameterSetByIdV2,
  GetParameterSetByIdV2PathParamsApi,
  getResourceDownloadLinkV2,
  getResourceSearchFieldValuesV2,
  getRkiConfigurationByOrganizationIdV2,
  getSystemPackageAuthorizedOrganizationsBySystemPackageIdV2,
  GetSystemPackageAuthorizedOrganizationsBySystemPackageIdV2QueryParamsApi,
  getSystemPackageByIdV2,
  getSystemPackageTemplatesBySystemPackageIdV2,
  getSystemPackageVersionTemplatesBySystemPackageVersionIdV2,
  getTemplateByIdV2,
  OrganizationResourceListResponseApi as OrganizationResourceListResponseApiV2,
  OsResourceReadV2Api,
  OsResourceWriteV2Api,
  OsVersionResourceReadV2Api,
  OutputFileContentApi,
  ParameterSetResourceReadV2Api,
  refreshEnvironmentsV2,
  searchApplicationsV2,
  SearchApplicationsV2ApiMutation,
  SearchApplicationsV2MutationRequestApi,
  SearchApplicationsV2QueryParamsApi,
  searchApplicationVersionsV2,
  SearchApplicationVersionsV2MutationRequestApi,
  SearchApplicationVersionsV2QueryParamsApi,
  searchCatalogSharesBffV2,
  SearchCatalogSharesBffV2MutationRequestApi,
  SearchCatalogSharesBffV2QueryParamsApi,
  searchConfigurationModulesBffV2,
  SearchConfigurationModulesBffV2QueryParamsApi,
  SearchConfigurationModulesV2MutationRequestApi,
  SearchConfigurationModulesV2QueryParamsApi,
  searchConfigurationsBffV2,
  searchConfigurationsV2,
  SearchConfigurationsV2ApiMutation,
  SearchConfigurationsV2MutationRequestApi,
  SearchConfigurationsV2QueryParamsApi,
  searchDeploymentAutomatorsV2,
  searchDeploymentRequestsBffV2,
  searchDeploymentUnitsBffV2,
  searchDeviceCallsV2,
  SearchDeviceCallsV2MutationRequestApi,
  SearchDeviceCallsV2QueryParamsApi,
  searchDeviceLogV2,
  SearchDeviceLogV2MutationRequestApi,
  SearchDeviceLogV2QueryParamsApi,
  searchDiagnosticsV2,
  SearchDiagnosticsV2MutationRequestApi,
  SearchDiagnosticsV2QueryParamsApi,
  SearchFilterApi,
  searchFilterFilterType,
  searchOperator,
  searchOsV2,
  SearchOsV2ApiMutation,
  searchOsVersionsV2,
  SearchOsVersionsV2MutationRequestApi,
  SearchOsVersionsV2QueryParamsApi,
  SearchRequestApi,
  SearchRequestApi as SearchRequestApiV2,
  searchResourcesV2,
  SearchResourcesV2MutationRequestApi,
  SearchResourcesV2QueryParamsApi,
  searchSystemPackagesV2,
  SearchSystemPackagesV2ApiMutation,
  SearchSystemPackagesV2MutationRequestApi,
  SearchSystemPackagesV2QueryParamsApi,
  searchSystemPackageVersionsV2,
  SearchSystemPackageVersionsV2MutationRequestApi,
  SearchSystemPackageVersionsV2QueryParamsApi,
  SystemPackageResourceReadV2Api,
  SystemPackageResourceWriteV2Api,
  SystemPackageVersionResourceListResponseV2Api,
  SystemPackageVersionResourceReadV2Api,
  TemplateResourceListResponseV2Api,
  triggerCatalogShareRevokeV2,
  updateApplicationAuthorizedOrganizationsByApplicationId,
  UpdateApplicationAuthorizedOrganizationsByApplicationIdMutationRequestApi,
  updateApplicationByIdV2,
  updateApplicationVersionByIdV2,
  updateCompleteParameterSetByIdV2,
  UpdateCompleteParameterSetByIdV2MutationRequestApi,
  modifyConfigurationByIdV2,
  updateConfigurationById,
  UpdateConfigurationByIdMutationRequestApi,
  updateConfigurationModuleByIdV2,
  UpdateConfigurationModuleByIdV2MutationRequestApi,
  updateDeploymentRequestById,
  UpdateDeploymentRequestByIdMutationRequestApi,
  updateEnvironmentByOrganizationIdV2,
  UpdateEnvironmentByOrganizationIdV2MutationRequestApi,
  updateOrganizationEnvironmentKeySetsV2,
  UpdateOrganizationEnvironmentKeySetsV2MutationRequestApi,
  updateOsAuthorizedOrganizationsByOsId,
  UpdateOsAuthorizedOrganizationsByOsIdMutationRequestApi,
  updateOsByIdV2,
  updateOsVersionByIdV2,
  updateParameterSetById,
  UpdateParameterSetByIdMutationRequestApi,
  updateRkiConfigurationByOrganizationId,
  UpdateRkiConfigurationByOrganizationIdMutationRequestApi,
  updateSystemPackageAuthorizedOrganizationsBySystemPackageId,
  UpdateSystemPackageAuthorizedOrganizationsBySystemPackageIdMutationRequestApi,
  updateSystemPackageByIdV2,
  updateSystemPackageVersionByIdV2,
  searchBffResourcesV2,
  ResourceDataFileResourceReadApi,
  updateResourceByIdV2,
  UpdateResourceByIdV2MutationRequestApi,
  getResourceByIdV2,
  downloadArtifactByIdV2,
  getDeploymentUnitSearchFieldValuesV2,
  createDeploymentAutomatorV2,
  deleteDeploymentAutomatorByIdV2,
  getOutputFilenamesForDeploymentUnitBffV2,
  ParameterSetListOutputFilesSearchBffV2Api,
  searchOutputFilesBffV2,
  SearchOutputFilesBffV2QueryParamsApi,
} from '@ingenico/api-sdk-device-management-private-v2';
import type {
  DeploymentRequestResourceTriggerDeviceListV2Api,
  LockScreenRequestApi,
  TriggerDeploymentRequestV2MutationResponseApi,
} from '@ingenico/api-sdk-device-management-public-v2';
import {
  createLockDeviceScreenByPhysicalDeviceIdV2,
  createUnlockDeviceScreenByPhysicalDeviceIdV2,
  getDeviceByIdV2,
  triggerDeploymentRequestV2,
} from '@ingenico/api-sdk-device-management-public-v2';
import {
  BffLogicalDeviceResourceReadApi,
  GenericUuidReadOnlyApi,
  getBffLogicalDeviceByIdV1,
  getBffOrganizationByIdV1,
  searchBffLogicalDevicesV1,
} from '@ingenico/api-sdk-provisioning-private';
import {
  blockPhysicalDeviceByIdV1,
  getLogicalDeviceFieldValuesV1,
  getLogicalDeviceSearchFieldsV1,
  getOrganizationFieldValuesV1,
  getOrganizationSearchFieldsV1,
  getPhysicalDevicesByLogicalDeviceIdV1,
  getSwappableStatusLogicalDeviceV1,
  PhysicalDeviceResourceReadApi,
  searchLogicalDevicesV1,
  SearchLogicalDevicesV1QueryParamsApi,
  searchOrganizationsV1,
  SearchOrganizationsV1MutationRequestApi,
  SearchOrganizationsV1QueryParamsApi,
  SearchRequestSortApi,
  searchPhysicalDevicesV1,
  unblockPhysicalDeviceByIdV1,
} from '@ingenico/api-sdk-provisioning-public';
import { getPhysicalDeviceInformationByPhysicalDeviceIdV1 } from '@ingenico/api-sdk-resource-private';
import { ArtifactCreationBody, ArtifactSimpleResource } from '@ingenico/react-form-builder';
import { CurrentSectionSpiIt, CustomDeviceFamily } from '@ingenico/react-section-utils';
import {
  MappedSmartFieldBffResourceWithRequiredApi,
  MappedSmartFieldResourceApi,
} from '@ingenico/react-smartfield-utils';
import {
  DeploymentTargetDeviceResourceById,
  DeviceCallResponse,
  DeviceChangeResourceApiByIdV2,
  MappedDynamicGroupResourceApi,
  SearchDynamicGroupsQueryParams,
  SearchRequest,
} from '@ingenico/react-ui';
import {
  AdvancedSearchStringOperators,
  FilterTypeEnum,
  type FieldConfiguration,
} from '@ingenico/react-ui/advanced-search';
import { inject, injectable } from 'inversify';
import { isEmpty, isEqual, toString } from 'lodash-es';
import { catchError, defer, forkJoin, map, mergeMap, Observable, of, retry, switchMap, throwError } from 'rxjs';
import { ApplicationVersionAutocompleteFieldValue } from '../../../components/application-version-fields/applicationVersionFields.model';
import { OverViewPayloadDTO, VersionDTO } from '../../../components/overview-tab/Overviewtab.model';
import { SystemPackageVersionAutocompleteFieldValue } from '../../../components/system-package-version-fields/systemPackageVersionFields.model';
import type { CreateLogRequestFormularySchema } from '../../../components/create-log-request-modal/hooks/useFormularyOfCreateLogRequest.hook';
import { AutomatorsSet, DynamicGroupListResponseFront, IConfigResourceBff } from '../../../model/configProfileV2.model';
import { IConfigProfileForDeploymentRequest } from '../../../model/deploymentRequest.model';
import type { DeviceAlerts } from '../../../model/deviceAlerts.model';
import type { DeviceCallLogDetail } from '../../../model/callLogs.model';
import type { DeviceLogsResponse } from '../../../model/deviceLogs.model';
import {
  ContentDetailsDTO,
  OsVersionList,
} from '../../../pages/os-application-details-page/OSApplicationDetailsPage.model';
import {
  buildNewParameterSet,
  filterCurrentVersionTemplatesBasedOnParameterSetAndNewVersionTemplates,
} from '../../../utils/configurationModule.util';
import {
  buildDeploymentAutomatorsBody,
  buildDynamicGroupsFilters,
  mapAutomatorsIds,
} from '../../../utils/deviceManagement.util';
import {
  mapCreateDeploymentAutomatorResponse,
  mapDynamicGroupsByConfigProfileId,
  mapFromOsResourceListToOsListApi,
  mapFromSearchFieldValueListToStringArray,
  mapOsArtifactsByOsVersionId,
  mapOsAssetsById,
  mapOsById,
  mapOsVersionByIdApi,
  mapOsVersionByOsId,
  mapOsVersionsByIdForApplication,
  mapOsVersionsByIdForSystemPackage,
  mapProfileGroupBodyToCreateDeploymentAutomatorV2MutationRequestApi,
  mapSmartFieldBffResourceApi,
} from '../../api/mappers';
import {
  mapApplicationById,
  mapBffOsVersionByApplicationId,
  mapOsVersionByApplicationIdOverview,
  mapOsVersionByApplicationIdVersion,
} from '../../api/mappers/applicationById.mapper';
import {
  mapApplicationListResponseApiToPaginatedApplicationList,
  mapApplicationsToSelectItems,
} from '../../api/mappers/applicationList.mapper';
import { mapApplicationVersionArtifactsById } from '../../api/mappers/applicationVersionArtifactsById.mapper';
import { mapUpdateDeploymentPriorityRequest } from '../../api/mappers/updateDeploymentPriority.mapper';
import {
  mapApplicationVersionById,
  mapBffApplicationVersionById,
} from '../../api/mappers/applicationVersionById.mapper';
import {
  mapApplicationVersionResourceReadApi,
  mapSearchApplicationVersionToSelectItems,
} from '../../api/mappers/applicationVersionListById.mapper';
import { mapApplicationVersionTemplatesById } from '../../api/mappers/applicationVersionTemplatesById.mapper';
import { mapGetAllApplicationVersionIdsFromApplication } from '../../api/mappers/applicationVersionsSearch.mapper';
import { mapArtifactsListForFormBuilderResponse } from '../../api/mappers/artifacts/getArtifactsListForFormBuilder.mapper';
import { mapLogoBlobToString } from '../../api/mappers/assets/assets.mapper';
import { mapCatalogSharesResponse, mapCreateCatalogShareRequest } from '../../api/mappers/catalogShare.mapper';
import { mapCatalogShareDetails } from '../../api/mappers/catalogShareDetails.mapper';
import { mapGetCategoriesResponse } from '../../api/mappers/categories.mapper';
import {
  mapConfigByIdBffV2,
  mapConfigurationProfilesForDeploymentRequest,
  mapDynamicGroupsList,
  mapGetDynamicGroupById,
} from '../../api/mappers/configV2.mapper';
import { mapConfigurationsList } from '../../api/mappers/configurationList.mapper';
import { mapConfigurationByIdResponse } from '../../api/mappers/configurationModuleById.mapper';
import { mapDuplicateBody, mapVersionsList } from '../../api/mappers/configurationModules.mapper';
import {
  mapConfigurationModuleResourceListBffResponseV2ToSelectItems,
  mapConfigurationModulesMinimalListToFieldConfiguration,
  mapModulesList,
} from '../../api/mappers/configurationModulesList.mapper';
import {
  mapGetConfigurationSnapshotById,
  mapParameterOutputList,
} from '../../api/mappers/configurationSnapshotById.mapper';
import { mapConfigurationModuleCreationParams } from '../../api/mappers/createConfigurationModule.mapper';
import { mapDeleteOrganizationEnvironmentResponse } from '../../api/mappers/deleteOrganizationEnvironment.mapper';
import { fromCreateLogRequestFormularySchemaToCreateDeviceLogSessionV2MutationRequestApi } from '../../api/mappers/createLogRequest.mapper';
import {
  mapDeviceCallLogsResponseApiToPaginatedDeviceCallLogsList,
  mapDeviceCallLogsResponseApiToPaginatedDeviceCallLogsListFront,
} from '../../api/mappers/deviceCallLogs.mapper';
import { mapCancelDeploymentBody } from '../../api/mappers/deployment/cancelDeployment.mapper';
import { mapGetDeploymentRequestById } from '../../api/mappers/deployment/deploymentById.mapper';
import { fromDeploymentRequestResourceListResponseV2ApiToPaginatedDeploymentRows } from '../../api/mappers/deployment/deploymentList.mapper';
import {
  mapDeployDeletionRequestBody,
  mapDeploymentRequestBody,
  mapDeploymentRequestResourceReadV2ApiToSimpleDeploymentRequestResponse,
} from '../../api/mappers/deployment/deploymentRequest.mapper';
import { mapDeploymentUnitResponseReadBFF } from '../../api/mappers/deployment/deploymentUnitById.mapper';
import {
  buildDeploymentUnitRequestBody,
  mapDeploymentUnitsResponse,
  mapMultipleDeploymentUnits,
} from '../../api/mappers/deployment/deploymentUnitList.mapper';
import { mapOutputFile, mapOutputFilesV2 } from '../../api/mappers/deployment/outputFile.mapper';
import { mapDeploymentDevicesDynamicGroupResponse } from '../../api/mappers/deploymentDevicesDynamicGroup.mapper';
import { mapUpdateDeploymentRequestByIdResponse } from '../../api/mappers/deploymentRequestById.mapper';
import { mapDeployUnitsCountResponse } from '../../api/mappers/deploymentUnits.mapper';
import {
  mapDeviceDiagnosticsResponseApiToDeviceDiagnosticsDetails,
  mapDeviceDiagnosticsResponseApiToPaginatedDeviceDiagnosticsList,
} from '../../api/mappers/deviceDiagnostics.mapper';
import { mapSearchDeviceLogsResponse } from '../../api/mappers/deviceLogs.mapper';
import { mapSearchDeviceCallsResponse } from '../../api/mappers/deviceCalls.mapper';
import { mapDeviceConnectionStatus } from '../../api/mappers/deviceConnectionStatus.mapper';
import {
  mapDeviceManagementArtifactsV2Response,
  mapDeviceManagementSystemPackageTemplatesResponse,
} from '../../api/mappers/deviceManagementArtifacts.mapper';
import { mapDeviceMetrics } from '../../api/mappers/deviceMetrics.mapper';
import { mapDeviceFamilyList } from '../../api/mappers/deviceModels.mapper';
import { mapEnvironmentsResponse } from '../../api/mappers/environmentsResponse.mapper';
import { mapGetDeviceAlertsResponse } from '../../api/mappers/getDeviceAlerts.mapper';
import { mapGetDeviceCallLogsByCallIdV1 } from '../../api/mappers/getDeviceCallLogsByCallIdV1.mapper';
import { mapGetOrganizationById } from '../../api/mappers/getOrganizationById.mapper';
import {
  mapLogicalDeviceListResponseApiToPaginatedLogicalDeviceList,
  mapLogicalDeviceMinimalListToFieldConfiguration,
  mapperGetTotalCountOfLogicalDeviceByDynamicGroup,
} from '../../api/mappers/logicalDeviceTotalList.mapper';
import { mapDeviceResourceReadV2Api } from '../../api/mappers/mapDeviceResourceReadV2Api.mapper';
import { mapOrganizationEnvironmentKeysetsResponse } from '../../api/mappers/organizationEnvironmentKeysetsResponse.mapper';
import { mapOrganizationEnvironmentResponse } from '../../api/mappers/organizationEnvironmentResponse.mapper';
import {
  mapOrganizationsAuthorizedList,
  mapOrganizationsAuthorizedListRefactored,
} from '../../api/mappers/organizationsAuthorizedList.mapper';
import { mapOrganizationMinimalListToFieldConfiguration } from '../../api/mappers/organizationsFields.mapper';
import { mapProvisioningOrganizationFieldsValues } from '../../api/mappers/os/provisioningOrganizationFieldsValues.mapper';
import { mapProvisioningOrganizationsList } from '../../api/mappers/os/provisioningOrganizationsList.mapper';
import { mapSearchOsVersionResponse } from '../../api/mappers/os/searchOsVersion.mapper';
import type { MergeParameterOutputFileModalReturn } from '../../api/mappers/parameterOutputFileModal.mapper';
import {
  mapSearchOutputFilenamesRequest,
  mergeParameterOutputFileModal,
} from '../../api/mappers/parameterOutputFileModal.mapper';
import { mapPhysicalDeviceInformationResponse } from '../../api/mappers/physicalDeviceInformation.mapper';
import { mapResourceArtifactCapabilities } from '../../api/mappers/resourceArtifactCapabilities.mapper';
import { mapCreateResourceResponse } from '../../api/mappers/resourceCreate.mapper';
import { mapEditResourceResponse } from '../../api/mappers/editResource.mapper';
import { mapResourcesListResponseApiToPaginatedResourceList } from '../../api/mappers/resourcesList.mapper';
import {
  getRkiConfigurationFormInput,
  mapConfigurationResourceRemoteKeyInjectionApiToRkiConfigurationV2,
  mapOrganizationEnvironmentKeysetsToRkiNames,
} from '../../api/mappers/rki.mapper';
import { mapBodySmartFieldResourceApi } from '../../api/mappers/smartFieldByIdBff.mapper';
import { mapSmartFieldsList } from '../../api/mappers/smartFields.mapper';
import { mapApplicationsList } from '../../api/mappers/softwareList.mapper';
import { mapBffSystemPackageVersionById, mapSystemPackageById } from '../../api/mappers/systemPackageById.mapper';
import {
  mapSearchSystemPackageVersionToSelectItems,
  mapSystemPackageListResponseApiV2ToPaginatedSystemPackageList,
  mapSystemPackageToSelectItems,
} from '../../api/mappers/systemPackageList.mapper';
import {
  mapSystemPackageVersionBySystemPackageIdOverview,
  mapSystemPackageVersionBySystemPackageIdVersion,
  mapSystemPackageVersionResourceReadApi,
} from '../../api/mappers/systemPackageVersionListById.mapper';
import { mapSystemPackagesVersionArtifactsById } from '../../api/mappers/systemPackagesVersionArtifactsById.mapper';
import {
  mapBffSystemPackagesVersionById,
  mapSystemPackagesVersionById,
} from '../../api/mappers/systemPackagesVersionById.mapper';
import { mapSystemPackagesVersionTemplatesById } from '../../api/mappers/systemPackagesVersionTemplatesById.mapper';
import { mapUploadedTemplateFile } from '../../api/mappers/template.mapper';
import { mapTemplateByIdResponse } from '../../api/mappers/templateById.mapper';
import { mapConfigurationModuleUpdateResponse } from '../../api/mappers/updateConfigurationModule.mapper';
import { mapUpdateEnvironmentByOrganizationIdResponse } from '../../api/mappers/updateEnvironmentByOrganizationId.mapper';
import { mapUpdateOrganizationEnvironmentKeySetsResponse } from '../../api/mappers/updateOrganizationEnvironmentKeySets.mapper';
import { mapUploadedApplicationFile } from '../../api/mappers/uploadApplicationFile.mapper';
import type { DeviceManagementSpiPort } from '../../hexa/ports/spi.model';
import { OrganizationsAuthorizations } from '../../models/OSContent.model';
import type { PaginatedApplicationList } from '../../models/applicationList.model';
import {
  ApplicationVersionArtifactsListResponseFront,
  ApplicationVersionListResponseFront,
  MappedApplicationVersionResourceListResponseV2Api,
  MappedBffApplicationVersionResourceReadV2Api,
  MappedUpdateApplicationVersionResourceV2Api,
  PutApplicationVersion,
  SystemPackageVersionListResponseFront,
  TemplateResourceListResponseFront,
} from '../../models/applicationVersion.model';
import { ArtifactRequest, ArtifactResource } from '../../models/artifact.model';
import type { AskDeviceUpdateRequest } from '../../models/askDeviceUpdate.model';
import type { CatalogShareSearchResponse } from '../../models/catalogShare.model';
import { CatalogShareDetails } from '../../models/catalogShare.model';
import type {
  DMSearchRequest,
  SearchFilter as SearchFilterCommon,
  SearchRequest as SearchRequestCommon,
} from '../../models/common.model';
import type { ConfigurationListMapped } from '../../models/configurationList.model';
import {
  ConfigurationModule,
  ConfigurationModuleParameterSet,
  ConfigurationModuleResource,
  ConfigurationModuleSoftwareVersionType,
  CreateConfigurationModuleParams,
  DuplicateModuleBody,
  ModuleVersion,
} from '../../models/configurationModules.model';
import { CancelDeploymentBody } from '../../models/deployment/cancelDeployment.model';
import { DeploymentRequestResource } from '../../models/deployment/deploymentById.model';
import {
  PaginatedDeploymentRows,
  SearchDeploymentRequestsBody,
  SearchDeploymentRequestsQueryParams,
} from '../../models/deployment/deploymentList.model';
import {
  DeploymentDevicesDynamicGroupQuery,
  DeploymentRequestBody,
  SimpleDeploymentRequestResponse,
} from '../../models/deployment/deploymentRequest.model';
import {
  DeploymentUnitsStatusCount,
  PaginatedDeploymentUnitResourceList,
  SearchDeploymentUnitsBody,
  SearchDeploymentUnitsQueryParams,
} from '../../models/deployment/deploymentUnitList.model';
import { ParameterSetsOutput } from '../../models/deployment/parameterSetsOutput.model';
import type { DeviceConnectionStatus } from '../../models/deviceConnectionStatus.model';
import type { DeviceInfo } from '../../models/deviceInfo.model';
import type { GetCallLogsDetailsInput } from '../../models/DeviceCallDetails.model';
import type {
  MappedDiagnosticsResourceApi,
  MappedDiagnosticsResourceListResponseApi,
} from '../../models/DeviceDiagnosticsDetails.model';
import { DeviceManagementArtifactResponse } from '../../models/deviceManagementArtifacts.model';
import type { DeviceMetrics } from '../../models/deviceMetrics.model';
import { EnvironmentsResponse } from '../../models/environments.model';
import { BffPaginatedLogicalDeviceList, PaginatedPublicLogicalDeviceList } from '../../models/logicalDeviceList.model';
import {
  IOrganization,
  ProvisioningOrganizationFieldValuesResponse,
  ProvisioningOrganizationListResponse,
} from '../../models/organization.model';
import {
  OrganizationEnvironment,
  OrganizationEnvironmentErrorType,
  OrganizationEnvironmentKeysetResponse,
} from '../../models/organizationEnvironment.model';
import { OsAssetsByIdResponse } from '../../models/osAssets.model';
import type { OsListResponseApiMapped } from '../../models/osList.model';
import { FileListOsVersionProps, PutOsVersion } from '../../models/osVersion.model';
import type { PhysicalDeviceInformation } from '../../models/physicalDeviceInformation.model';
import { RkiConfigurationFormulary, RkiDeviceGroupsName } from '../../models/rkiConfiguration.model';
import { SearchOsVersionResponse } from '../../models/searchOsVersion.model';
import type { SelectItems } from '../../models/selectItems.model';
import { SoftwareType } from '../../models/selectItems.model';
import { SmartFieldCategory, SmartFieldsListMappedResponse } from '../../models/smartFields.model';
import type { ConfigurationResourceFront, ModuleItemField } from '../../models/snapshot.model';
import type { ApplicationsList } from '../../models/softwareList.model';
import type {
  MappedSystemPackageVersionResourceListResponseV2Api,
  PaginatedSystemPackageListV2,
  PutSystemPackageVersion,
  SystemPackageArtifactListResponseFront,
} from '../../models/systemPackage.model';
import type { SystemPackageVersionResource } from '../../models/systemPackageVersion.model';
import type {
  PaginatedResourceList,
  ResourceArtifactCapabilitiesFront,
  ResourceListItemFront,
} from '../../models/resources.model';
import { TemplateRequest, TemplateResponseResourceFront } from '../../models/template.model';
import { TemplateDetailedResource } from '../../models/templateResource.model';
import { mapBffLogicalDeviceListResponseApiToPaginatedLogicalDeviceList } from '../../api/mappers/logicalDeviceList.mapper';
import { mapAttachmentsList, mapAttachmentStatus } from '../../api/mappers/getAttachments.mapper';
import { MappedAttachmentsResponseApi } from '../../models/attachments.model';
import { mapDeviceChangeResourceApi } from '../../api/mappers/deviceChangesById.mapper';
import { DeviceCallLogsResponseApiFront } from '../../../model/deviceCallLogs.model';
import {
  ProfileGroupBody,
  SimpleCreateDeploymentAutomatorResponse,
} from '../../models/deployment/createDeploymentAutomator.model';

@injectable()
export class DeviceManagementService {
  private readonly apiSdkClient: CoreClient;

  constructor(@inject(CurrentSectionSpiIt) spi: DeviceManagementSpiPort) {
    this.apiSdkClient = spi.getApiSdkClient();
  }

  getOrganizationById(organizationId: string): Observable<IOrganization> {
    return this.apiSdkClient.request(getBffOrganizationByIdV1(organizationId)).pipe(map(mapGetOrganizationById));
  }

  /**
   * Get the application list (server side).
   * this one does not fetch all the application list at once.
   * See the "getApplications" for this behavior.
   *
   * @param body
   * @param params
   * @param isRefetch
   * @param disableCache
   */
  getApplicationList({
    body,
    params,
    isRefetch = false,
    disableCache = false,
  }: {
    body: SearchApplicationsV2ApiMutation['Request'];
    params?: SearchApplicationsV2QueryParamsApi;
    isRefetch?: boolean;
    disableCache?: boolean;
  }): Observable<PaginatedApplicationList> {
    return this.apiSdkClient
      .request(searchApplicationsV2(body, params), { isRefetch, disableCache })
      .pipe(map((response) => mapApplicationListResponseApiToPaginatedApplicationList(response)));
  }

  getApplicationVersionListById({
    body,
    params,
  }: {
    body: SearchApplicationVersionsV2MutationRequestApi;
    params?: SearchApplicationVersionsV2QueryParamsApi;
  }): Observable<ApplicationVersionListResponseFront> {
    return this.apiSdkClient
      .request(searchApplicationVersionsV2(body, params))
      .pipe(map(mapApplicationVersionResourceReadApi));
  }

  searchApplicationForNameAndId(
    body: SearchApplicationsV2MutationRequestApi,
    params?: SearchApplicationsV2QueryParamsApi,
  ): Observable<SelectItems[]> {
    return this.apiSdkClient.request(searchApplicationsV2(body, params)).pipe(map(mapApplicationsToSelectItems));
  }

  searchSystemPackageForNameAndId(
    body: SearchSystemPackagesV2MutationRequestApi,
    params?: SearchSystemPackagesV2QueryParamsApi,
  ): Observable<SelectItems[]> {
    return this.apiSdkClient.request(searchSystemPackagesV2(body, params)).pipe(map(mapSystemPackageToSelectItems));
  }

  searchSoftwareNameItems(
    type: SoftwareType,
    searchFilter?: string,
    params?: SearchApplicationsV2QueryParamsApi | SearchSystemPackagesV2QueryParamsApi,
  ): Observable<SelectItems[]> {
    const body = {
      filters: [
        ...(searchFilter
          ? [
              {
                filterType: FilterTypeEnum.FullText,
                name: '',
                operator: 'equals',
                value: `*${searchFilter}*`,
              } satisfies SearchFilterApi,
            ]
          : []),
      ],
      sort: {},
    };

    return type === SoftwareType.Application
      ? this.searchApplicationForNameAndId(body, params as SearchApplicationsV2QueryParamsApi)
      : this.searchSystemPackageForNameAndId(body, params as SearchSystemPackagesV2QueryParamsApi);
  }

  searchApplicationVersionByNameAndId(
    body: SearchApplicationVersionsV2MutationRequestApi,
    params?: SearchApplicationVersionsV2QueryParamsApi,
  ): Observable<SelectItems[]> {
    return this.apiSdkClient
      .request(searchApplicationVersionsV2(body, params))
      .pipe(map(mapSearchApplicationVersionToSelectItems));
  }

  searchSystemPackageVersionByNameAndId(
    body: SearchSystemPackageVersionsV2MutationRequestApi,
    params?: SearchSystemPackageVersionsV2QueryParamsApi,
  ): Observable<SelectItems[]> {
    return this.apiSdkClient
      .request(searchSystemPackageVersionsV2(body, params))
      .pipe(map(mapSearchSystemPackageVersionToSelectItems));
  }

  searchSoftwareVersionItems(
    type: SoftwareType,
    id: string,
    searchFilter?: string,
    params?: SearchApplicationVersionsV2QueryParamsApi | SearchSystemPackageVersionsV2QueryParamsApi,
  ): Observable<SelectItems[]> {
    const fullTextFilters = searchFilter
      ? [
          {
            filterType: FilterTypeEnum.FullText,
            name: '',
            operator: 'equals',
            value: `*${searchFilter}*`,
          } satisfies SearchFilterApi,
        ]
      : [];

    return type === SoftwareType.Application
      ? this.searchApplicationVersionByNameAndId(
          {
            filters: [
              {
                filterType: FilterTypeEnum.String,
                name: 'applicationVersion.applicationId',
                operator: AdvancedSearchStringOperators.Equals,
                value: id,
              },
              {
                filterType: FilterTypeEnum.String,
                name: 'applicationVersion.configurationType',
                operator: AdvancedSearchStringOperators.Equals,
                value: 'WITH_PARAMETERS',
              },
              ...fullTextFilters,
            ],
            sort: {
              field: 'applicationVersion.versionNumber',
              order: 'DESC',
            },
          },
          params as SearchApplicationVersionsV2QueryParamsApi,
        )
      : this.searchSystemPackageVersionByNameAndId(
          {
            filters: [
              {
                filterType: FilterTypeEnum.String,
                name: 'systemPackageVersion.systemPackageId',
                operator: AdvancedSearchStringOperators.Equals,
                value: id,
              },
              {
                filterType: FilterTypeEnum.String,
                name: 'systemPackageVersion.configurationType',
                operator: AdvancedSearchStringOperators.Equals,
                value: 'WITH_PARAMETERS',
              },
              ...fullTextFilters,
            ],
            sort: {
              field: 'systemPackageVersion.versionNumber',
              order: 'DESC',
            },
          },
          params as SearchSystemPackageVersionsV2QueryParamsApi,
        );
  }

  searchConfigurationModuleSelectiItems(
    softwareVersionId: string,
    searchFilter?: string,
    params?: SearchConfigurationModulesBffV2QueryParamsApi,
  ): Observable<SelectItems[]> {
    return this.apiSdkClient
      .request(
        searchConfigurationModulesBffV2(
          {
            filters: [
              {
                filterType: FilterTypeEnum.String,
                name: 'configurationModule.softwareVersion.id',
                operator: AdvancedSearchStringOperators.Equals,
                value: softwareVersionId,
              },
              ...(searchFilter
                ? [
                    {
                      filterType: FilterTypeEnum.FullText,
                      name: '',
                      operator: 'equals',
                      value: `*${searchFilter}*`,
                    } satisfies SearchFilterApi,
                  ]
                : []),
            ],
            sort: {},
          },
          params,
        ),
      )
      .pipe(map(mapConfigurationModuleResourceListBffResponseV2ToSelectItems));
  }

  getSystemPackagesFullList({
    body,
    params,
    isRefetch,
    disableCache,
  }: {
    body: SearchSystemPackagesV2ApiMutation['Request'];
    params?: SearchSystemPackagesV2ApiMutation['QueryParams'];
    isRefetch?: boolean;
    disableCache?: boolean;
  }): Observable<PaginatedSystemPackageListV2> {
    return this.apiSdkClient
      .request(searchSystemPackagesV2(body, params), { isRefetch, disableCache })
      .pipe(map(mapSystemPackageListResponseApiV2ToPaginatedSystemPackageList));
  }

  getSystemPackageVersionListById({
    body,
    params,
  }: {
    body: SearchSystemPackageVersionsV2MutationRequestApi;
    params?: SearchSystemPackageVersionsV2QueryParamsApi;
  }): Observable<SystemPackageVersionListResponseFront> {
    return this.apiSdkClient
      .request(searchSystemPackageVersionsV2(body, params))
      .pipe(map(mapSystemPackageVersionResourceReadApi));
  }

  getResourcesList({
    body,
    params,
    isRefetch,
    disableCache,
  }: {
    body: SearchRequestApi;
    params?: SearchResourcesV2QueryParamsApi;
    isRefetch?: boolean;
    disableCache?: boolean;
  }): Observable<PaginatedResourceList> {
    return this.apiSdkClient
      .request(searchBffResourcesV2(body, params), { isRefetch, disableCache })
      .pipe(map((response) => mapResourcesListResponseApiToPaginatedResourceList(response)));
  }

  getResourceFieldValues(field: string, isRefetch?: boolean): Observable<string[]> {
    return this.apiSdkClient
      .request(getResourceSearchFieldValuesV2(field), { isRefetch })
      .pipe(map(mapFromSearchFieldValueListToStringArray));
  }

  getResourceArtifactCapabilities(): Observable<ResourceArtifactCapabilitiesFront> {
    return this.apiSdkClient.request(getArtifactCapabilitiesV2()).pipe(map(mapResourceArtifactCapabilities));
  }

  createResource(body: CreateResourceV2MutationRequestApi): Observable<ResourceDataFileResourceReadApi> {
    return this.apiSdkClient.request(createResourceV2(body)).pipe(map(mapCreateResourceResponse));
  }

  deleteResource(resourceId: string): Observable<unknown> {
    return this.apiSdkClient.request(deleteResourceByIdV2(resourceId));
  }

  getOsList({
    body,
    params,
    isRefetch,
  }: {
    body: SearchOsV2ApiMutation['Request'];
    params?: SearchOsV2ApiMutation['QueryParams'];
    isRefetch?: boolean;
  }): Observable<OsListResponseApiMapped> {
    return this.apiSdkClient
      .request(searchOsV2(body, params), { isRefetch })
      .pipe(map(mapFromOsResourceListToOsListApi));
  }

  getOsVersionsByIdForSystemPackage({
    body,
    params,
  }: {
    body: SearchOsVersionsV2MutationRequestApi;
    params?: SearchOsVersionsV2QueryParamsApi;
  }): Observable<SystemPackageVersionAutocompleteFieldValue[]> {
    return this.apiSdkClient.request(searchOsVersionsV2(body, params)).pipe(map(mapOsVersionsByIdForSystemPackage));
  }

  getOsVersionsByIdForApplication({
    body,
    params,
  }: {
    body: SearchOsVersionsV2MutationRequestApi;
    params?: SearchOsVersionsV2QueryParamsApi;
  }): Observable<ApplicationVersionAutocompleteFieldValue[]> {
    return this.apiSdkClient.request(searchOsVersionsV2(body, params)).pipe(map(mapOsVersionsByIdForApplication));
  }

  getConfigurationList(
    query: {
      body: SearchConfigurationsV2ApiMutation['Request'];
      params?: SearchConfigurationsV2QueryParamsApi;
    },
    isRefetch = false,
  ): Observable<ConfigurationListMapped> {
    return this.apiSdkClient
      .request(searchConfigurationsBffV2(query.body, query.params), { isRefetch })
      .pipe(map(mapConfigurationsList));
  }

  getSystemPackagesVersionById(
    systemPackagesVersionId: string,
    isRefetch = false,
  ): Observable<SystemPackageVersionResource> {
    return this.apiSdkClient
      .request(getBffSystemPackageVersionByIdV2(systemPackagesVersionId), { isRefetch })
      .pipe(map(mapBffSystemPackagesVersionById));
  }

  putSystemPackagesVersion({
    systemPackagesVersionId,
    body,
  }: PutSystemPackageVersion): Observable<SystemPackageVersionResource> {
    return this.apiSdkClient
      .request(updateSystemPackageVersionByIdV2(systemPackagesVersionId, body))
      .pipe(map(mapSystemPackagesVersionById));
  }

  getSystemPackagesVersionTemplatesById(
    systemPackagesVersionId: string,
  ): Observable<TemplateResourceListResponseFront> {
    return this.apiSdkClient
      .request(getSystemPackageVersionTemplatesBySystemPackageVersionIdV2(systemPackagesVersionId))
      .pipe(map(mapSystemPackagesVersionTemplatesById));
  }

  getSystemPackagesVersionArtifactsById(
    systemPackagesVersionId: string,
  ): Observable<SystemPackageArtifactListResponseFront> {
    return this.apiSdkClient
      .request(getAllSystemPackageVersionArtifactsBySystemPackageVersionIdV2(systemPackagesVersionId))
      .pipe(map(mapSystemPackagesVersionArtifactsById));
  }

  getApplicationVersionById(
    applicationVersionId: string,
    isRefetch = false,
  ): Observable<MappedBffApplicationVersionResourceReadV2Api> {
    return this.apiSdkClient
      .request(getBffApplicationVersionByIdV2(applicationVersionId), { isRefetch })
      .pipe(map(mapBffApplicationVersionById));
  }

  putApplicationVersion({
    applicationVersionId,
    body,
  }: PutApplicationVersion): Observable<MappedUpdateApplicationVersionResourceV2Api> {
    return this.apiSdkClient
      .request(updateApplicationVersionByIdV2(applicationVersionId, body))
      .pipe(map(mapApplicationVersionById));
  }

  getApplicationVersionTemplatesById(applicationVersionId: string): Observable<TemplateResourceListResponseV2Api> {
    return this.apiSdkClient
      .request(getApplicationVersionTemplatesByApplicationVersionIdV2(applicationVersionId))
      .pipe(map(mapApplicationVersionTemplatesById));
  }

  getApplicationVersionArtifactsById(
    applicationVersionId: string,
  ): Observable<ApplicationVersionArtifactsListResponseFront> {
    return this.apiSdkClient
      .request(getApplicationVersionArtifactByApplicationVersionIdV2(applicationVersionId))
      .pipe(map(mapApplicationVersionArtifactsById));
  }

  getRkiConfigurationByOrganizationId({
    organizationId,
    isRefetch = false,
  }: {
    organizationId: string;
    isRefetch: boolean;
  }): Observable<RkiConfigurationFormulary> {
    return this.apiSdkClient
      .request(getRkiConfigurationByOrganizationIdV2(organizationId), { isRefetch })
      .pipe(map(getRkiConfigurationFormInput));
  }

  getKeySetReferences(isRefetch = false): Observable<RkiDeviceGroupsName> {
    return this.apiSdkClient
      .request(getKeySetReferenceV2(), { isRefetch })
      .pipe(map(mapConfigurationResourceRemoteKeyInjectionApiToRkiConfigurationV2));
  }

  refreshEnvironmentsDataV2(): Observable<void> {
    return defer(() => this.apiSdkClient.request(refreshEnvironmentsV2({}))).pipe(
      retry(1),
      map(() => void 0),
      catchError(() => of(void 0)),
    );
  }

  getKeySetReferencesV2(organizationId: string, isRefetch = false): Observable<RkiDeviceGroupsName> {
    return this.getOrganizationEnvironment(organizationId, { isRefetch }).pipe(
      switchMap((environment) =>
        environment.id
          ? this.getOrganizationKeySets(organizationId, environment.id, { isRefetch }).pipe(
              map(mapOrganizationEnvironmentKeysetsToRkiNames),
            )
          : of([]),
      ),
    );
  }

  editConfigurationNameAndDescriptionMutation(
    configurationId: string,
    body: UpdateConfigurationByIdMutationRequestApi,
  ): Observable<ConfigurationResourceReadV2Api> {
    return this.apiSdkClient.request(updateConfigurationById(configurationId, body));
  }

  editConfigurationDeploymentPriorityMutation(
    configurationId: string,
    deploymentPriority?: number,
  ): Observable<ConfigurationResourceReadV2Api> {
    return this.apiSdkClient
      .request(getConfigurationByIdV2(configurationId), { disableCache: true })
      .pipe(
        switchMap((configuration) =>
          this.apiSdkClient.request(
            modifyConfigurationByIdV2(
              configurationId,
              mapUpdateDeploymentPriorityRequest(configuration, deploymentPriority),
            ),
          ),
        ),
      );
  }

  updateRkiConfigurationByOrganizationId({
    body: { submissionMethod, environment, domain },
    organizationId,
  }: {
    body: RkiConfigurationFormulary;
    organizationId: string;
  }): Observable<ConfigurationResourceRemoteKeyInjectionBasicApi> {
    return isEqual(submissionMethod, 'PATCH')
      ? this.patchRkiConfigurationByOrganizationId({
          body: {
            environment,
            ...(domain?.trim() ? { domain: domain.trim() } : {}),
          },
          organizationId,
        })
      : this.postRkiConfigurationByOrganizationId({
          body: {
            environment,
            ...(domain?.trim() ? { domain: domain.trim() } : {}),
          },
          organizationId,
        });
  }

  postRkiConfigurationByOrganizationId({
    organizationId,
    body,
  }: {
    organizationId: string;
    body: CreateRkiConfigurationByOrganizationIdV2MutationRequestApi;
  }): Observable<ConfigurationResourceRemoteKeyInjectionBasicApi> {
    return this.apiSdkClient.request(createRkiConfigurationByOrganizationIdV2(organizationId, body));
  }

  patchRkiConfigurationByOrganizationId({
    organizationId,
    body,
  }: {
    organizationId: string;
    body: UpdateRkiConfigurationByOrganizationIdMutationRequestApi;
  }): Observable<ConfigurationResourceRemoteKeyInjectionBasicApi> {
    return this.apiSdkClient.request(updateRkiConfigurationByOrganizationId(organizationId, body));
  }

  getDeviceFamilies(): Observable<CustomDeviceFamily[]> {
    return this.apiSdkClient.request(getDeviceModelsV1()).pipe(map(mapDeviceFamilyList));
  }

  createApplication(application: ApplicationResourceWriteV2Api): Observable<ApplicationResourceReadV2Api> {
    return this.apiSdkClient.request(createApplicationV2(application));
  }

  getApplicationById(
    applicationId: string,
    isRefetch = false,
  ): Observable<
    Omit<
      OverViewPayloadDTO,
      'latestVersion' | 'latestVersionId' | 'markdown' | 'OSVersion' | 'publicationDate' | 'subtitle'
    >
  > {
    return this.apiSdkClient
      .request(getApplicationByIdV2(applicationId), { isRefetch })
      .pipe(map((response) => mapApplicationById(response)));
  }

  getCatalogShareDetails(catalogShareId: string): Observable<CatalogShareDetails> {
    return this.apiSdkClient.request(getCatalogShareByIdBffV2(catalogShareId)).pipe(map(mapCatalogShareDetails));
  }

  downloadLogoByIdV2(assetId: string, isRefetch?: boolean): Observable<string> {
    return this.apiSdkClient
      .request(downloadAssetByIdV2(assetId), { isRefetch })
      .pipe(mergeMap((response: Blob) => mapLogoBlobToString(response)));
  }

  searchApplicationVersions(
    {
      body,
      params,
      disableCache,
    }: {
      body: SearchApplicationVersionsV2MutationRequestApi;
      params?: SearchApplicationVersionsV2QueryParamsApi;
      disableCache?: boolean;
    },
    isRefetch = false,
  ): Observable<MappedApplicationVersionResourceListResponseV2Api> {
    return this.apiSdkClient
      .request(searchApplicationVersionsV2(body, params), { isRefetch, disableCache })
      .pipe(map(mapOsVersionByApplicationIdVersion));
  }

  getOsVersionsByApplicationIdOverview(
    {
      body,
      params,
    }: {
      body: SearchApplicationVersionsV2MutationRequestApi;
      params?: SearchApplicationVersionsV2QueryParamsApi;
    },
    isRefetch = false,
  ): Observable<
    Pick<OverViewPayloadDTO, 'latestVersion' | 'latestVersionId' | 'markdown' | 'OSVersion' | 'publicationDate'>[]
  > {
    return this.apiSdkClient
      .request(searchApplicationVersionsV2(body, params), { isRefetch })
      .pipe(map(mapOsVersionByApplicationIdOverview));
  }

  getBffOsVersionsByApplicationId(
    applicationVersionId: string,
  ): Observable<Pick<OverViewPayloadDTO, 'applicationVersion' | 'OSVersion' | 'systemPackageVersion'>> {
    return this.apiSdkClient
      .request(getBffApplicationVersionByIdV2(applicationVersionId))
      .pipe(map((response) => mapBffOsVersionByApplicationId(response)));
  }

  getOSById(
    osId: string,
    isRefetch = false,
  ): Observable<Omit<ContentDetailsDTO, 'latestVersion' | 'markdown' | 'OSVersion' | 'publicationDate'>> {
    return this.apiSdkClient.request(getOsByIdV2(osId), { isRefetch }).pipe(map(mapOsById));
  }

  getOsVersionFromAnOs({
    body,
    params,
  }: {
    body: SearchOsVersionsV2MutationRequestApi;
    params?: SearchOsVersionsV2QueryParamsApi;
  }): Observable<OsVersionList> {
    return this.apiSdkClient.request(searchOsVersionsV2(body, params)).pipe(map(mapOsVersionByOsId));
  }

  putOsVersion({ osVersionId, body }: PutOsVersion): Observable<OsVersionResourceReadV2Api> {
    return this.apiSdkClient.request(updateOsVersionByIdV2(osVersionId, body));
  }

  createSystemPackage(
    systemPackage: CreateSystemPackageV2MutationRequestApi,
  ): Observable<SystemPackageResourceReadV2Api> {
    return this.apiSdkClient.request(createSystemPackageV2(systemPackage));
  }

  createOs(os: CreateOsV2MutationRequestApi): Observable<OsResourceReadV2Api> {
    return this.apiSdkClient.request(createOsV2(os));
  }

  createConfigurationProfile(
    body: CreateConfigurationV2MutationRequestApi,
  ): Observable<CreateConfigurationV2MutationResponseApi> {
    return this.apiSdkClient.request(createConfigurationV2(body));
  }

  getOsVersionByOsId(osVersionId: string, isRefetch = false): Observable<OsVersionResourceReadV2Api> {
    return this.apiSdkClient.request(getOsVersionByIdV2(osVersionId), { isRefetch }).pipe(map(mapOsVersionByIdApi));
  }

  getOsArtifactsByOsVersionId(osVersionId: string): Observable<FileListOsVersionProps> {
    return this.apiSdkClient
      .request(getAllOsVersionArtifactsByOsVersionIdV2(osVersionId))
      .pipe(map(mapOsArtifactsByOsVersionId));
  }

  getOSAuthorizedOrganizationsById(
    osId: string,
    params?: GetOsAuthorizedOrganizationsByOsIdV2QueryParamsApi,
    isRefetch = false,
  ): Observable<OrganizationsAuthorizations> {
    return this.apiSdkClient
      .request(getOsAuthorizedOrganizationsByOsIdV2(osId, params), { isRefetch })
      .pipe(map(mapOrganizationsAuthorizedListRefactored));
  }

  updateOSAuthorizedOrganizationsById({
    organizations,
    osId,
  }: {
    organizations: UpdateOsAuthorizedOrganizationsByOsIdMutationRequestApi;
    osId: string;
  }): Observable<OrganizationResourceListResponseApi> {
    return this.apiSdkClient.request(updateOsAuthorizedOrganizationsByOsId(osId, organizations));
  }

  getApplicationAuthorizedOrganizationsById(
    applicationId: string,
    params?: GetApplicationOrganizationsByApplicationIdV2QueryParamsApi,
    isRefetch = false,
  ): Observable<OrganizationResourceListResponseApiV2> {
    return this.apiSdkClient
      .request(getApplicationOrganizationsByApplicationIdV2(applicationId, params), { isRefetch })
      .pipe(map(mapOrganizationsAuthorizedList));
  }

  updateApplicationAuthorizedOrganizationsById({
    organizations,
    applicationId,
  }: {
    organizations: UpdateApplicationAuthorizedOrganizationsByApplicationIdMutationRequestApi;
    applicationId: string;
  }): Observable<OrganizationResourceListResponseApi> {
    return this.apiSdkClient.request(
      updateApplicationAuthorizedOrganizationsByApplicationId(applicationId, organizations),
    );
  }

  getSystemPackageAuthorizedOrganizationsById(
    systemPackageId: string,
    params?: GetSystemPackageAuthorizedOrganizationsBySystemPackageIdV2QueryParamsApi,
    isRefetch = false,
  ): Observable<OrganizationResourceListResponseApi> {
    return this.apiSdkClient
      .request(getSystemPackageAuthorizedOrganizationsBySystemPackageIdV2(systemPackageId, params), { isRefetch })
      .pipe(map(mapOrganizationsAuthorizedList));
  }

  updateSystemPackageAuthorizedOrganizationsById({
    organizations,
    systemPackageId,
  }: {
    organizations: UpdateSystemPackageAuthorizedOrganizationsBySystemPackageIdMutationRequestApi;
    systemPackageId: string;
  }): Observable<OrganizationResourceListResponseApi> {
    return this.apiSdkClient.request(
      updateSystemPackageAuthorizedOrganizationsBySystemPackageId(systemPackageId, organizations),
    );
  }

  deleteConfigurationProfile(configurationId: string): Observable<DeleteConfigurationByIdV1MutationResponseApi> {
    return this.apiSdkClient.request(deleteConfigurationByIdV1(configurationId));
  }

  getSystemPackageById(
    systemPackageId: string,
    isRefetch = false,
  ): Observable<
    Omit<
      OverViewPayloadDTO,
      'latestVersion' | 'latestVersionId' | 'markdown' | 'OSVersion' | 'publicationDate' | 'subtitle'
    >
  > {
    return this.apiSdkClient
      .request(getSystemPackageByIdV2(systemPackageId), { isRefetch })
      .pipe(map((response) => mapSystemPackageById(response)));
  }

  getBffSystemPackageVersionById(systemPackagesVersionId: string): Observable<{ OSVersion: VersionDTO }> {
    return this.apiSdkClient
      .request(getBffSystemPackageVersionByIdV2(systemPackagesVersionId))
      .pipe(map(mapBffSystemPackageVersionById));
  }

  getFullSystemPackageVersionsByIdOverview({
    body,
    params,
  }: {
    body: SearchSystemPackageVersionsV2MutationRequestApi;
    params?: SearchSystemPackageVersionsV2QueryParamsApi;
  }): Observable<
    Pick<OverViewPayloadDTO, 'latestVersion' | 'latestVersionId' | 'markdown' | 'OSVersion' | 'publicationDate'>[]
  > {
    return this.apiSdkClient
      .request(searchSystemPackageVersionsV2(body, params))
      .pipe(map(mapSystemPackageVersionBySystemPackageIdOverview));
  }

  searchSystemPackageVersions(
    {
      body,
      params,
      disableCache,
    }: {
      body: SearchSystemPackageVersionsV2MutationRequestApi;
      params?: SearchSystemPackageVersionsV2QueryParamsApi;
      disableCache?: boolean;
    },
    isRefetch = false,
  ): Observable<MappedSystemPackageVersionResourceListResponseV2Api> {
    return this.apiSdkClient
      .request(searchSystemPackageVersionsV2(body, params), { isRefetch, disableCache })
      .pipe(map((response) => mapSystemPackageVersionBySystemPackageIdVersion(response)));
  }

  getProvisioningOrganizationsList(
    {
      body,
      params,
    }: {
      body: SearchOrganizationsV1MutationRequestApi;
      params?: SearchOrganizationsV1QueryParamsApi;
    },
    isRefetch = false,
  ): Observable<ProvisioningOrganizationListResponse> {
    return this.apiSdkClient
      .request(searchOrganizationsV1(body, params), { isRefetch })
      .pipe(map(mapProvisioningOrganizationsList));
  }

  getProvisioningOrganizationsListForPublishModal(
    {
      body,
    }: {
      body: SearchOrganizationsV1MutationRequestApi;
    },
    isRefetch = false,
  ): Observable<ProvisioningOrganizationListResponse> {
    return this.apiSdkClient
      .requestFullDataOfPaginatedResponse((params) => searchOrganizationsV1(body, params), { isRefetch })
      .pipe(map(mapProvisioningOrganizationsList));
  }

  getProvisioningOrganizationFields(): Observable<FieldConfiguration[]> {
    return this.apiSdkClient
      .request(getOrganizationSearchFieldsV1())
      .pipe(map(mapOrganizationMinimalListToFieldConfiguration));
  }

  getProvisioningOrganizationFieldsValues(field: string): Observable<ProvisioningOrganizationFieldValuesResponse> {
    return this.apiSdkClient
      .request(getOrganizationFieldValuesV1(field))
      .pipe(map(mapProvisioningOrganizationFieldsValues));
  }

  editApplicationProperties({
    applicationProperties,
    applicationId,
  }: {
    applicationProperties: ApplicationResourceWriteV2Api;
    applicationId: string;
  }): Observable<ApplicationResourceReadV2Api> {
    return this.apiSdkClient.request(updateApplicationByIdV2(applicationId, applicationProperties));
  }

  editSystemPackage({
    systemPackage,
    systemPackageId,
  }: {
    systemPackage: SystemPackageResourceWriteV2Api;
    systemPackageId: string;
  }): Observable<SystemPackageResourceReadV2Api> {
    return this.apiSdkClient.request(updateSystemPackageByIdV2(systemPackageId, systemPackage));
  }

  editOs({ os, osId }: { os: OsResourceWriteV2Api; osId: string }): Observable<OsResourceReadV2Api> {
    return this.apiSdkClient.request(updateOsByIdV2(osId, os));
  }

  createArtifact(applicationFile: ArtifactRequest): Observable<ArtifactResource> {
    const params: CreateArtifactV2QueryParamsApi = {
      artifactName: applicationFile.artifactName,
      artifactType: applicationFile.type,
      checksum: applicationFile.checksum,
      componentType: applicationFile.componentType,
    };

    return this.apiSdkClient
      .request(createArtifactV2(applicationFile.file, params))
      .pipe(map(mapUploadedApplicationFile));
  }

  createSystemPackageVersion(
    systemPackage: CreateSystemPackageVersionV2MutationRequestApi,
  ): Observable<SystemPackageVersionResourceReadV2Api> {
    return this.apiSdkClient.request(createSystemPackageVersionV2(systemPackage));
  }

  createOsVersion(osVersion: CreateOsVersionV2MutationRequestApi): Observable<OsVersionResourceReadV2Api> {
    return this.apiSdkClient.request(createOsVersionV2(osVersion));
  }

  createApplicationVersion(
    application: CreateApplicationVersionV2MutationRequestApi,
  ): Observable<ApplicationVersionResourceReadV2Api> {
    return this.apiSdkClient.request(createApplicationVersionV2(application));
  }

  getApplicationArtifactsById(applicationId: string): Observable<DeviceManagementArtifactResponse> {
    return this.apiSdkClient
      .requestFullDataOfPaginatedResponse((params) => getApplicationArtifactsByApplicationIdV2(applicationId, params))
      .pipe(map(mapDeviceManagementArtifactsV2Response));
  }

  getApplicationTemplatesById(applicationId: string): Observable<DeviceManagementArtifactResponse> {
    return this.apiSdkClient
      .requestFullDataOfPaginatedResponse((params) => getApplicationTemplatesByApplicationIdV2(applicationId, params))
      .pipe(map(mapDeviceManagementSystemPackageTemplatesResponse));
  }

  getSysPackageArtifactsBySysPackageId(systemPackageId: string): Observable<DeviceManagementArtifactResponse> {
    return this.apiSdkClient
      .requestFullDataOfPaginatedResponse((params) =>
        getAllSystemPackageArtifactsBySystemPackageIdV2(systemPackageId, params),
      )
      .pipe(map(mapDeviceManagementArtifactsV2Response));
  }

  getSysPackageTemplatesBySysPackageId(systemPackageId: string): Observable<DeviceManagementArtifactResponse> {
    return this.apiSdkClient
      .requestFullDataOfPaginatedResponse((params) =>
        getSystemPackageTemplatesBySystemPackageIdV2(systemPackageId, params),
      )
      .pipe(map(mapDeviceManagementSystemPackageTemplatesResponse));
  }

  getSystemPackages({
    body,
    params,
  }: {
    body: SearchSystemPackagesV2MutationRequestApi;
    params?: SearchSystemPackagesV2QueryParamsApi;
  }): Observable<PaginatedSystemPackageListV2> {
    return this.apiSdkClient
      .request(searchSystemPackagesV2(body, params))
      .pipe(map(mapSystemPackageListResponseApiV2ToPaginatedSystemPackageList));
  }

  /**
   * Get all the application at once (fetch all application on front side).
   *
   * @param body
   */
  getApplications({
    body,
    params,
    disableCache,
  }: {
    body: SearchApplicationsV2MutationRequestApi;
    params?: SearchApplicationsV2QueryParamsApi;
    disableCache?: boolean;
  }): Observable<PaginatedApplicationList> {
    return this.apiSdkClient
      .request(searchApplicationsV2(body, params), { disableCache })
      .pipe(map(mapApplicationListResponseApiToPaginatedApplicationList));
  }

  createCategory(body: CreateCategoryV1MutationRequestApi): Observable<CategoryResourceReadApi> {
    return this.apiSdkClient.request(createCategoryV1(body));
  }

  createTemplate(templateFile: TemplateRequest): Observable<TemplateResponseResourceFront> {
    return this.apiSdkClient
      .request(
        createTemplateV2(templateFile.file, {
          templateName: templateFile.templateName,
          checksum: templateFile.checksum,
          componentType: templateFile.componentType,
        }),
      )
      .pipe(map(mapUploadedTemplateFile));
  }

  getOsAssetsById(osId: string, isRefetch?: boolean): Observable<OsAssetsByIdResponse> {
    return this.apiSdkClient.request(getOsAssetsByOsIdV2(osId), { isRefetch }).pipe(map(mapOsAssetsById));
  }

  searchOsVersion({
    body,
    params,
  }: {
    body: SearchOsVersionsV2MutationRequestApi;
    params?: SearchOsVersionsV2QueryParamsApi;
  }): Observable<SearchOsVersionResponse> {
    return this.apiSdkClient.request(searchOsVersionsV2(body, params)).pipe(map(mapSearchOsVersionResponse));
  }

  searchConfigurationModules(
    {
      body,
      params,
    }: {
      body: SearchConfigurationModulesV2MutationRequestApi;
      params?: SearchConfigurationModulesV2QueryParamsApi;
    },
    isRefetch?: boolean,
  ) {
    return this.apiSdkClient
      .request(searchConfigurationModulesBffV2(body, params), { isRefetch })
      .pipe(map(mapModulesList));
  }

  getConfigurationModuleSearchFields(): Observable<FieldConfiguration[]> {
    return this.apiSdkClient
      .request(getConfigurationModuleSearchFieldsV2())
      .pipe(map(mapConfigurationModulesMinimalListToFieldConfiguration));
  }

  /* -------------------------------------------------------------------------- */
  /*                             DEPLOYMENT (START)                             */
  /* -------------------------------------------------------------------------- */

  getDeploymentList({
    body,
    params,
    isRefetch,
  }: {
    body: SearchDeploymentRequestsBody;
    params?: SearchDeploymentRequestsQueryParams;
    isRefetch?: boolean;
  }): Observable<PaginatedDeploymentRows> {
    return this.apiSdkClient
      .request(searchDeploymentRequestsBffV2(body, params), { isRefetch })
      .pipe(map(fromDeploymentRequestResourceListResponseV2ApiToPaginatedDeploymentRows));
  }

  getDeploymentRequestById(deploymentRequestId: string, isRefetch?: boolean): Observable<DeploymentRequestResource> {
    return this.apiSdkClient
      .request(getDeploymentRequestByIdBffV2(deploymentRequestId), { isRefetch })
      .pipe(map(mapGetDeploymentRequestById));
  }

  searchDeploymentUnits(
    {
      body,
      params,
    }: {
      body: SearchDeploymentUnitsBody;
      params?: SearchDeploymentUnitsQueryParams;
    },
    isRefetch?: boolean,
  ): Observable<PaginatedDeploymentUnitResourceList> {
    return this.apiSdkClient
      .request(searchDeploymentUnitsBffV2(body, params), { isRefetch })
      .pipe(map(mapDeploymentUnitsResponse));
  }

  searchDeploymentUnitsByStatus(deploymentId: string): Observable<DeploymentUnitsStatusCount> {
    const statuses = [
      '["COMPLETED"]',
      '["SCHEDULED","WAITING_ATTACHMENT","RUNNING","CREATED","PAUSED","QUEUED"]',
      '["CANCELED"]',
      '["FAILED"]',
    ];
    const requests = statuses.map((status) =>
      this.apiSdkClient.request(
        searchDeploymentUnitsBffV2(buildDeploymentUnitRequestBody(deploymentId, status), { offset: 0, limit: 1 }),
      ),
    );

    return forkJoin(requests).pipe(map(mapMultipleDeploymentUnits));
  }

  getDeploymentUnitById(targetDeviceId: string, isRefetch = false): Observable<DeploymentTargetDeviceResourceById> {
    return this.apiSdkClient
      .request(getDeploymentUnitByIdBffV2(targetDeviceId), { isRefetch })
      .pipe(map(mapDeploymentUnitResponseReadBFF));
  }

  /**
   * Retrieves output file names for a deployment unit.
   * The API currently does not expose pagination parameters on this endpoint.
   */
  getOutputFilenamesForDeploymentUnit(deploymentUnitId: string): Observable<ParameterSetsOutput> {
    return this.apiSdkClient.request(getOutputFilenamesForDeploymentUnitV2(deploymentUnitId)).pipe(map(mapOutputFile));
  }

  /**
   * Retrieves output file names for a deployment unit.
   * The API currently does not expose pagination parameters on this endpoint.
   */
  getOutputFilenamesForDeploymentUnitBffV2(deploymentUnitId: string): Observable<ParameterSetsOutput> {
    return this.apiSdkClient
      .request(getOutputFilenamesForDeploymentUnitBffV2(deploymentUnitId))
      .pipe(map(mapOutputFilesV2));
  }

  createDeploymentRequest(
    data: DeploymentRequestBody,
    initialGroupsQuery: SearchRequestCommon | undefined,
    additionalFiltersMapped?: SearchFilterCommon[],
    isProgressiveDeploymentEnabled = false,
  ): Observable<SimpleDeploymentRequestResponse> {
    return this.apiSdkClient
      .request(
        createDeploymentRequestV2(
          mapDeploymentRequestBody(data, initialGroupsQuery, additionalFiltersMapped, isProgressiveDeploymentEnabled),
        ),
      )
      .pipe(map(mapDeploymentRequestResourceReadV2ApiToSimpleDeploymentRequestResponse));
  }

  deployDeletionRequest(
    data: DeploymentRequestBody,
    additionalFiltersMapped?: SearchFilterCommon[],
    isProgressiveDeploymentEnabled = false,
  ): Observable<SimpleDeploymentRequestResponse> {
    return this.apiSdkClient
      .request(
        createDeploymentRequestV2(
          mapDeployDeletionRequestBody(data, additionalFiltersMapped, isProgressiveDeploymentEnabled),
        ),
      )
      .pipe(map(mapDeploymentRequestResourceReadV2ApiToSimpleDeploymentRequestResponse));
  }

  cancelDeployment({
    deploymentRequestId,
    body,
  }: {
    deploymentRequestId: string;
    body: CancelDeploymentBody;
  }): Observable<SimpleDeploymentRequestResponse> {
    return this.apiSdkClient
      .request(createActionOnDeploymentRequestByIdV2(deploymentRequestId, mapCancelDeploymentBody(body)))
      .pipe(map(mapDeploymentRequestResourceReadV2ApiToSimpleDeploymentRequestResponse));
  }

  /* -------------------------------------------------------------------------- */
  /*                              DEPLOYMENT (END)                              */
  /* -------------------------------------------------------------------------- */

  getConfigurationSnapshotById(configurationSnapshotId: string): Observable<ConfigurationResourceFront> {
    return this.apiSdkClient
      .request(getConfigurationSnapshotByIdBffV2(configurationSnapshotId))
      .pipe(map(mapGetConfigurationSnapshotById));
  }

  getBffConfigurationSnapshotById(
    configurationSnapshotId: string,
  ): Observable<ConfigurationResourceSnapshotReadBffV2Api> {
    return this.apiSdkClient.request(getConfigurationSnapshotByIdBffV2(configurationSnapshotId));
  }

  getSnapshotListForViewOutput(configurationSnapshotId: string): Observable<ModuleItemField[]> {
    return this.getBffConfigurationSnapshotById(configurationSnapshotId).pipe(map(mapParameterOutputList));
  }

  getConfigurationByIdBffV2Query(configurationId: string, isRefetch?: boolean): Observable<IConfigResourceBff> {
    return this.apiSdkClient
      .request(getConfigurationByIdBffV2(configurationId), { isRefetch })
      .pipe(map((response) => mapConfigByIdBffV2(response)));
  }

  getDynamicGroupById({
    dynamicGroupId,
    isRefetch = false,
  }: {
    dynamicGroupId: string;
    isRefetch?: boolean;
  }): Observable<MappedDynamicGroupResourceApi> {
    return this.apiSdkClient
      .request(getDynamicGroupByIdBffV1(dynamicGroupId), { isRefetch })
      .pipe(map(mapGetDynamicGroupById));
  }

  getPublicLogicalDeviceList(
    filters: SearchFilterApi[],
    sort: SearchRequestSortApi,
    params?: SearchLogicalDevicesV1QueryParamsApi,
    isRefetch?: boolean,
  ): Observable<PaginatedPublicLogicalDeviceList> {
    return this.apiSdkClient
      .request(searchLogicalDevicesV1({ filters, sort }, params), { isRefetch })
      .pipe(map((response) => mapLogicalDeviceListResponseApiToPaginatedLogicalDeviceList(response)));
  }

  getLogicalDevicesTotalCountFromDynamicGroup({
    searchRequest,
    params,
    isRefetch,
  }: {
    searchRequest: SearchRequestApi;
    params?: SearchLogicalDevicesV1QueryParamsApi;
    isRefetch?: boolean;
  }): Observable<number> {
    return this.getPublicLogicalDeviceList(searchRequest.filters, searchRequest.sort, params, isRefetch).pipe(
      map(mapperGetTotalCountOfLogicalDeviceByDynamicGroup),
    );
  }

  getSmartFieldBffById(
    smartFieldId: string,
    isRefetch?: boolean,
  ): Observable<MappedSmartFieldBffResourceWithRequiredApi> {
    return this.apiSdkClient
      .request(getSmartFieldByIdBffV1(smartFieldId), { isRefetch })
      .pipe(map(mapSmartFieldBffResourceApi));
  }

  createSmartFieldV1(body: CreateSmartFieldV1MutationRequestApi): Observable<MappedSmartFieldResourceApi> {
    return this.apiSdkClient.request(createSmartFieldV1(body)).pipe(map(mapBodySmartFieldResourceApi));
  }

  searchSmartFieldsBff({
    body,
    params,
  }: {
    body: SearchSmartFieldsBffV1MutationRequestApi;
    params?: SearchSmartFieldsBffV1QueryParamsApi;
  }): Observable<SmartFieldsListMappedResponse> {
    return this.apiSdkClient.request(searchSmartFieldsBffV1(body, params)).pipe(map(mapSmartFieldsList));
  }

  getLogicalDeviceFields(): Observable<FieldConfiguration[]> {
    return this.apiSdkClient
      .request(getLogicalDeviceSearchFieldsV1())
      .pipe(map((response) => mapLogicalDeviceMinimalListToFieldConfiguration(response)));
  }

  getLogicalDeviceFieldValues(field: string): Observable<string[]> {
    return this.apiSdkClient.request(getLogicalDeviceFieldValuesV1(field));
  }

  getTemplateById(id: string, config?: { disableCache?: boolean }): Observable<TemplateDetailedResource> {
    return this.apiSdkClient
      .request(getTemplateByIdV2(id), { disableCache: config?.disableCache })
      .pipe(map(mapTemplateByIdResponse));
  }

  getParameterSetById(
    parameterSetId: GetParameterSetByIdV2PathParamsApi['parameterSetId'],
  ): Observable<ParameterSetResourceReadV2Api> {
    return this.apiSdkClient.request(getParameterSetByIdV2(parameterSetId));
  }

  createParameterSet(body: CreateParameterSetV2MutationRequestApi): Observable<ParameterSetResourceReadV2Api> {
    return this.apiSdkClient.request(createParameterSetV2(body));
  }

  patchParameterSetById(
    parameterSetId: string,
    body: UpdateParameterSetByIdMutationRequestApi,
  ): Observable<ParameterSetResourceReadV2Api> {
    return this.apiSdkClient.request(updateParameterSetById(parameterSetId, body));
  }

  replaceParameterSetById(
    parameterSetId: string,
    body: UpdateCompleteParameterSetByIdV2MutationRequestApi,
  ): Observable<ParameterSetResourceReadV2Api> {
    return this.apiSdkClient.request(updateCompleteParameterSetByIdV2(parameterSetId, body));
  }

  getConfigurationModuleById(
    id: string,
    config?: Partial<Record<'disableCache' | 'isRefetch', boolean>>,
  ): Observable<ConfigurationModule> {
    return this.apiSdkClient
      .request(getConfigurationModuleByIdBffV2(id), {
        disableCache: config?.disableCache,
        isRefetch: config?.isRefetch,
      })
      .pipe(map(mapConfigurationByIdResponse));
  }

  createConfigurationModule(params: CreateConfigurationModuleParams) {
    return this.apiSdkClient.request(createConfigurationModuleV2(mapConfigurationModuleCreationParams(params)));
  }

  deleteConfigurationById(configurationId: string) {
    return this.apiSdkClient.request(deleteConfigurationByIdV2(configurationId));
  }

  getConfigurationProfilesForDeploymentRequest(
    body: SearchConfigurationsV2MutationRequestApi,
  ): Observable<IConfigProfileForDeploymentRequest[]> {
    return this.apiSdkClient
      .request(searchConfigurationsV2(body, { limit: 50, offset: 0 }))
      .pipe(map(mapConfigurationProfilesForDeploymentRequest));
  }

  deleteModule(id: string): Observable<unknown> {
    return this.apiSdkClient.request(deleteConfigurationModuleByIdV2(id));
  }

  searchApplicationOrSystemPackageVersions(
    body: SearchRequestApiV2,
    type: ConfigurationModuleSoftwareVersionType,
    params?: { offset?: number; limit?: number },
  ): Observable<ModuleVersion[]> {
    return this.apiSdkClient
      .request(
        type === 'APPLICATION_VERSION'
          ? searchApplicationVersionsV2(body, params)
          : searchSystemPackageVersionsV2(body, params),
      )
      .pipe(
        map((response: ApplicationVersionResourceListResponseV2Api | SystemPackageVersionResourceListResponseV2Api) =>
          mapVersionsList(response),
        ),
      );
  }

  duplicateConfigurationModule(
    body: DuplicateModuleBody,
    parameterSets: ConfigurationModuleParameterSet[],
    moduleSoftwareId: string,
  ): Observable<CreateConfigurationModuleV2MutationResponseApi> {
    return body.isUpgrade
      ? forkJoin(
          body.softwareType === 'APPLICATION_VERSION'
            ? [
                this.apiSdkClient.request(getApplicationVersionTemplatesByApplicationVersionIdV2(moduleSoftwareId)),
                this.apiSdkClient.request(
                  getApplicationVersionTemplatesByApplicationVersionIdV2(toString(body.softwareVersionId)),
                ),
              ]
            : [
                this.apiSdkClient.request(getSystemPackageVersionTemplatesBySystemPackageVersionIdV2(moduleSoftwareId)),
                this.apiSdkClient.request(
                  getSystemPackageVersionTemplatesBySystemPackageVersionIdV2(toString(body.softwareVersionId)),
                ),
              ],
        ).pipe(
          map(([currentVersionTemplates, newVersionTemplates]) =>
            filterCurrentVersionTemplatesBasedOnParameterSetAndNewVersionTemplates(
              currentVersionTemplates,
              newVersionTemplates,
              parameterSets,
            ),
          ),
          switchMap((matchingNewTemplates) => {
            return isEmpty(matchingNewTemplates)
              ? this.apiSdkClient.request(createConfigurationModuleV2(mapDuplicateBody(body, [])))
              : forkJoin(
                  matchingNewTemplates.map((matchingTemplate) =>
                    this.apiSdkClient.request(getTemplateByIdV2(matchingTemplate.newId)),
                  ),
                ).pipe(
                  switchMap((fetchedTemplates) =>
                    this.apiSdkClient.request(
                      createConfigurationModuleV2(
                        mapDuplicateBody(
                          body,
                          buildNewParameterSet(fetchedTemplates, matchingNewTemplates, parameterSets),
                        ),
                      ),
                    ),
                  ),
                );
          }),
        )
      : this.apiSdkClient.request(createConfigurationModuleV2(mapDuplicateBody(body, parameterSets)));
  }

  updateConfigurationModuleById(
    id: string,
    body: UpdateConfigurationModuleByIdV2MutationRequestApi,
  ): Observable<ConfigurationModuleResource> {
    return this.apiSdkClient
      .request(updateConfigurationModuleByIdV2(id, body))
      .pipe(
        map((response) =>
          mapConfigurationModuleUpdateResponse(response as CreateConfigurationModuleV2MutationRequestApi),
        ),
      );
  }

  searchCategoriesForMap(
    body: ConfigurationSearchRequestApi,
    params?: SearchCategoriesV1QueryParamsApi,
  ): Observable<SmartFieldCategory[]> {
    return this.apiSdkClient
      .request(searchCategoriesV1(body, params))
      .pipe(map((response) => mapGetCategoriesResponse(response)));
  }

  triggerDeploymentRequests(devices: string[]): Observable<TriggerDeploymentRequestV2MutationResponseApi> {
    return this.apiSdkClient.request(triggerDeploymentRequestV2({ devices }));
  }

  blockDeviceScreen(physicalDeviceId: string, body: LockScreenRequestApi): Observable<unknown> {
    return this.apiSdkClient.request(createLockDeviceScreenByPhysicalDeviceIdV2(physicalDeviceId, body));
  }

  unblockDeviceScreen(physicalDeviceId: string): Observable<unknown> {
    return this.apiSdkClient.request(createUnlockDeviceScreenByPhysicalDeviceIdV2(physicalDeviceId, {}));
  }

  searchDeviceCalls({
    body,
    deviceId,
  }: {
    deviceId: string;
    body: SearchDeviceCallsV2MutationRequestApi;
  }): Observable<DeviceCallResponse> {
    return this.apiSdkClient
      .requestFullDataOfPaginatedResponse((params) => searchDeviceCallsV2(deviceId, body, params))
      .pipe(map(mapSearchDeviceCallsResponse));
  }

  getAllApplicationVersionIdsFromApplication({ applicationId }: { applicationId: string }): Observable<string[]> {
    return this.apiSdkClient
      .requestFullDataOfPaginatedResponse((params) =>
        searchApplicationVersionsV2(
          {
            filters: [
              {
                filterType: searchFilterFilterType.string,
                name: 'applicationVersion.applicationId',
                operator: searchOperator.equals,
                value: applicationId,
              },
            ],
            sort: {},
          },
          params,
        ),
      )
      .pipe(map(mapGetAllApplicationVersionIdsFromApplication));
  }

  searchDynamicGroupsByConfigurationProfileId(
    configurationId: string,
    query: { body: SearchRequest; params: SearchDynamicGroupsQueryParams },
    handleSetAutomators?: (automators: AutomatorsSet[]) => void,
    automatorsIds?: AutomatorsSet[],
    isRefetch?: boolean,
  ): Observable<DynamicGroupListResponseFront> {
    return (
      automatorsIds
        ? of(automatorsIds)
        : this.apiSdkClient
            .requestFullDataOfPaginatedResponse(
              (params) => searchDeploymentAutomatorsV2(buildDeploymentAutomatorsBody(configurationId), params),
              { isRefetch },
            )
            .pipe(
              map((response) => {
                const newAutomators = mapAutomatorsIds(response);
                handleSetAutomators?.(newAutomators);
                return newAutomators;
              }),
            )
    ).pipe(
      switchMap((newAutomatorsIds) => {
        return isEmpty(newAutomatorsIds)
          ? of({ data: [], automatorIds: [], pagination: {} } as DynamicGroupListResponseFront)
          : this.apiSdkClient
              .request(
                searchDynamicGroupsBffV1(
                  {
                    filters: buildDynamicGroupsFilters(newAutomatorsIds, query.body.filters),
                    sort: query.body.sort,
                  },
                  query.params,
                ),
                { isRefetch },
              )
              .pipe(map((response) => mapDynamicGroupsByConfigProfileId(response, newAutomatorsIds)));
      }),
    );
  }

  /* -------------------------------------------------------------------------- */
  /*                        PARAMETER OUTPUT FILE METHODS                       */
  /* -------------------------------------------------------------------------- */

  getConfigurationModuleSnapshotById(configurationModuleSnapshotId: string) {
    return this.apiSdkClient.request(getConfigurationModuleSnapshotByIdBffV2(configurationModuleSnapshotId));
  }

  getOutputFilenamesForDeploymentUnitNonPipe(deploymentUnitId: string) {
    return this.apiSdkClient.request(getOutputFilenamesForDeploymentUnitBffV2(deploymentUnitId));
  }
  downloadOutputFileForTemplate(
    deploymentUnitId: string,
    templateId: string,
    outputFileName: string,
  ): Observable<OutputFileContentApi> {
    return this.apiSdkClient.request(downloadOutputFileForTemplateV2(deploymentUnitId, templateId, outputFileName));
  }

  useDeploymentUnitParameterOutputFileModalWorkflow(
    deploymentUnitId: string,
    parameterOutput: ModuleItemField,
  ): Observable<MergeParameterOutputFileModalReturn> {
    return forkJoin({
      configurationModule: this.getConfigurationModuleSnapshotById(parameterOutput.configurationModuleId),
      outputFilenames: this.getOutputFilenamesForDeploymentUnitNonPipe(deploymentUnitId),
    }).pipe(map(mergeParameterOutputFileModal));
  }

  useParameterOutputFileModal(
    deploymentUnitId: string,
    parameterOutput: ModuleItemField,
  ): Observable<MergeParameterOutputFileModalReturn> {
    return this.useDeploymentUnitParameterOutputFileModalWorkflow(deploymentUnitId, parameterOutput);
  }

  pureSearchOutputFilesBff(
    body: SearchRequestApi,
    params?: SearchOutputFilesBffV2QueryParamsApi,
  ): Observable<ParameterSetListOutputFilesSearchBffV2Api> {
    return this.apiSdkClient.request(searchOutputFilesBffV2(body, params));
  }

  pureGetConfigurationModuleByIdBff(
    configurationModuleId: string,
  ): Observable<ConfigurationModuleResourceReadBffV2Api> {
    return this.apiSdkClient.request(getConfigurationModuleByIdBffV2(configurationModuleId));
  }

  useParameterOutputFileModalFromDeviceDetails(
    configurationId: string,
    logicalDeviceId?: string,
  ): Observable<MergeParameterOutputFileModalReturn> {
    return this.pureGetConfigurationModuleByIdBff(configurationId).pipe(
      mergeMap((configurationModule) =>
        this.pureSearchOutputFilesBff(
          mapSearchOutputFilenamesRequest({
            parameterSetIds: configurationModule.parameterSets.map(({ id }) => id),
            logicalDeviceId,
          }),
        ).pipe(
          map((outputFilenames) =>
            mergeParameterOutputFileModal({
              configurationModule,
              outputFilenames,
              errorPrefix: 'DEVICE-OUTPUT-VIEW',
            }),
          ),
        ),
      ),
    );
  }

  pureDownloadOutputFile(
    deviceId: string,
    parameterSetId: string,
    outputFileName: string,
  ): Observable<OutputFileContentApi> {
    return this.apiSdkClient.request(downloadOutputFileV2(deviceId, parameterSetId, outputFileName));
  }

  updateDeploymentRequestById(
    deploymentRequestId: string,
    body: UpdateDeploymentRequestByIdMutationRequestApi,
  ): Observable<DeploymentRequestResource> {
    return this.apiSdkClient
      .request(updateDeploymentRequestById(deploymentRequestId, body))
      .pipe(map(mapUpdateDeploymentRequestByIdResponse));
  }

  getPrivateLogicalDeviceList(
    filters: SearchFilterApi[],
    sort: SearchRequestSortApi,
    params?: SearchLogicalDevicesV1QueryParamsApi,
    isRefetch?: boolean,
  ): Observable<PaginatedPublicLogicalDeviceList> {
    return this.apiSdkClient
      .request(searchBffLogicalDevicesV1({ filters, sort }, params), { isRefetch })
      .pipe(map((response) => mapLogicalDeviceListResponseApiToPaginatedLogicalDeviceList(response)));
  }

  getLogicalDeviceByDynamicGroupId(dynamicGroupId: string): Observable<PaginatedPublicLogicalDeviceList> {
    return this.apiSdkClient.request(getDynamicGroupByIdBffV1(dynamicGroupId)).pipe(
      switchMap((response) => {
        const searchRequest = response?.searchRequest;
        return this.getPrivateLogicalDeviceList(searchRequest?.filters ?? [], searchRequest?.sort ?? {}, {
          limit: 1,
          offset: 0,
        });
      }),
    );
  }

  getDeployUnitsCountByDynamicGroupId(dynamicGroupId: string): Observable<DeploymentUnitsStatusCount> {
    return this.getLogicalDeviceByDynamicGroupId(dynamicGroupId).pipe(map(mapDeployUnitsCountResponse));
  }

  getDeployUnitsCountByDynamicGroupQuery(searchQuery?: DMSearchRequest): Observable<DeploymentUnitsStatusCount> {
    return this.getPrivateLogicalDeviceList(searchQuery?.filters ?? [], searchQuery?.sort ?? {}, {
      limit: 1,
      offset: 0,
    }).pipe(map(mapDeployUnitsCountResponse));
  }

  getDeploymentDevicesDynamicGroupQueryById(
    dynamicGroupId: string,
    isRefetch?: boolean,
  ): Observable<DeploymentDevicesDynamicGroupQuery> {
    return this.getDynamicGroupById({ dynamicGroupId, isRefetch }).pipe(map(mapDeploymentDevicesDynamicGroupResponse));
  }

  getOrganizationEnvironment(
    organizationId: string,
    {
      disableCache,
      isRefetch,
    }: {
      disableCache?: boolean;
      isRefetch?: boolean;
    },
  ): Observable<OrganizationEnvironment> {
    return this.apiSdkClient
      .request(getEnvironmentByOrganizationIdV2(organizationId), { isRefetch, disableCache })
      .pipe(map(mapOrganizationEnvironmentResponse));
  }

  getOrganizationKeySets(
    organizationId: string,
    environmentId: string,
    { disableCache, isRefetch }: { disableCache?: boolean; isRefetch?: boolean } = {},
  ): Observable<OrganizationEnvironmentKeysetResponse> {
    return this.apiSdkClient
      .request(getOrganizationKeySetsV2(organizationId, environmentId), { isRefetch, disableCache })
      .pipe(map(mapOrganizationEnvironmentKeysetsResponse));
  }

  getEnvironments(): Observable<EnvironmentsResponse> {
    return this.apiSdkClient
      .requestFullDataOfPaginatedResponse((params) => getAllEnvironmentsV2(params))
      .pipe(map(mapEnvironmentsResponse));
  }

  // The endpoint returns an unknown interface, that is why the return type is Observable<unknown>
  deleteOrganizationEnvironment(organizationId: string, environmentId: string): Observable<unknown> {
    return this.apiSdkClient
      .request(deleteEnvironmentByOrganizationIdV2(organizationId, environmentId))
      .pipe(map(mapDeleteOrganizationEnvironmentResponse));
  }

  updateEnvironmentByOrganizationId(
    organizationId: string,
    body: UpdateEnvironmentByOrganizationIdV2MutationRequestApi,
  ): Observable<OrganizationEnvironment> {
    return this.apiSdkClient
      .request(updateEnvironmentByOrganizationIdV2(organizationId, body))
      .pipe(map(mapUpdateEnvironmentByOrganizationIdResponse));
  }

  updateOrganizationEnvironmentKeySets(
    organizationId: string,
    environmentId: string,
    body: UpdateOrganizationEnvironmentKeySetsV2MutationRequestApi,
  ): Observable<OrganizationEnvironmentKeysetResponse> {
    return this.apiSdkClient
      .request(updateOrganizationEnvironmentKeySetsV2(organizationId, environmentId, body))
      .pipe(map(mapUpdateOrganizationEnvironmentKeySetsResponse));
  }

  patchOrganizationEnvironment({
    currentEnvironment,
    newEnvironment,
    organizationId,
  }: {
    readonly currentEnvironment: string;
    readonly newEnvironment: string;
    readonly organizationId: string;
  }): Observable<unknown> {
    return of(void 0).pipe(
      switchMap(() => {
        if (isEmpty(currentEnvironment) && !isEmpty(newEnvironment)) {
          return this.updateEnvironmentByOrganizationId(organizationId, {
            id: newEnvironment,
          }).pipe(
            catchError(() =>
              throwError(() => ({
                data: { type: 'error', title: OrganizationEnvironmentErrorType.ASSIGN_ENVIRONMENT },
              })),
            ),
          );
        } else if (
          !isEmpty(currentEnvironment) &&
          !isEmpty(newEnvironment) &&
          !isEqual(currentEnvironment, newEnvironment)
        ) {
          return this.deleteOrganizationEnvironment(organizationId, currentEnvironment)
            .pipe(
              catchError(() =>
                throwError(() => ({
                  data: { type: 'error', title: OrganizationEnvironmentErrorType.DELETE_ENVIRONMENT },
                })),
              ),
            )
            .pipe(
              switchMap(() =>
                this.updateEnvironmentByOrganizationId(organizationId, {
                  id: newEnvironment,
                }).pipe(
                  catchError(() =>
                    throwError(() => ({
                      data: { type: 'error', title: OrganizationEnvironmentErrorType.ASSIGN_ENVIRONMENT },
                    })),
                  ),
                ),
              ),
            );
        } else {
          return of(void 0);
        }
      }),
    );
  }

  updateOrganizationEnvironmentKeySetsIfDifferent({
    organizationId,
    environmentId,
    currentKeysetIds,
    newKeysetIds,
  }: {
    organizationId: string;
    environmentId: string;
    currentKeysetIds: string[];
    newKeysetIds: string[];
  }): Observable<unknown> {
    return isEqual(newKeysetIds, currentKeysetIds)
      ? of(void 0)
      : this.updateOrganizationEnvironmentKeySets(organizationId, environmentId, { keysetIds: newKeysetIds }).pipe(
          catchError(() =>
            throwError(() => ({
              data: { type: 'error', title: OrganizationEnvironmentErrorType.UPDATE_KEYSETS },
            })),
          ),
        );
  }

  getLogicalDeviceDetailsBff(
    logicalDeviceId: GenericUuidReadOnlyApi,
    { isRefetch, disableCache }: { isRefetch?: boolean; disableCache?: boolean } = {},
  ): Observable<BffLogicalDeviceResourceReadApi> {
    return this.apiSdkClient.request(getBffLogicalDeviceByIdV1(logicalDeviceId), { isRefetch, disableCache });
  }

  getPhysicalDeviceInformation(physicalDeviceId: string): Observable<PhysicalDeviceInformation> {
    return this.apiSdkClient
      .request(getPhysicalDeviceInformationByPhysicalDeviceIdV1(physicalDeviceId))
      .pipe(map((response) => mapPhysicalDeviceInformationResponse(response, physicalDeviceId)));
  }

  getDeviceMetrics({ deviceId }: { readonly deviceId: string }): Observable<DeviceMetrics> {
    return this.apiSdkClient
      .request(getDeviceMetricsByDeviceIdV2(deviceId), { disableCache: true })
      .pipe(map((response) => mapDeviceMetrics(response, deviceId)));
  }

  getMultipleDeviceMetrics(params: { readonly deviceId: string }[]): Observable<DeviceMetrics[]> {
    return forkJoin(
      params.map(({ deviceId }) =>
        this.getDeviceMetrics({ deviceId }).pipe(catchError(() => of(mapDeviceMetrics(undefined, deviceId)))),
      ),
    );
  }

  getDeviceIdV2({ deviceId }: { readonly deviceId: string }): Observable<DeviceInfo> {
    return this.apiSdkClient
      .request(getDeviceByIdV2(deviceId), { disableCache: true })
      .pipe(map((response) => mapDeviceResourceReadV2Api(response, deviceId)));
  }

  getDeviceLogsByIdV2({
    deviceId,
    body,
    params,
  }: {
    readonly deviceId: string;
    readonly body: SearchRequestApi;
    readonly params?: SearchDeviceLogV2QueryParamsApi;
  }): Observable<DeviceLogResourceListResponseApi> {
    return this.apiSdkClient.request(searchDeviceLogV2(deviceId, body, params));
  }

  getDeviceDiagnosticDetailsByDeviceIdAndDiagnosticId({
    diagnosticId,
    deviceId,
  }: {
    readonly deviceId: string;
    readonly diagnosticId: string;
  }): Observable<MappedDiagnosticsResourceApi> {
    return this.apiSdkClient
      .request(getDeviceDiagnosticByDeviceIdAndDiagnosticIdV2(deviceId, diagnosticId))
      .pipe(
        map((response: GetDeviceDiagnosticByDeviceIdAndDiagnosticIdV2QueryResponseApi) =>
          mapDeviceDiagnosticsResponseApiToDeviceDiagnosticsDetails(response),
        ),
      );
  }

  getSearchDeviceDiagnostics({
    body,
    params,
    deviceId,
  }: {
    readonly deviceId: string;
    readonly body: SearchDiagnosticsV2MutationRequestApi;
    readonly params?: SearchDiagnosticsV2QueryParamsApi;
  }): Observable<MappedDiagnosticsResourceListResponseApi> {
    return this.apiSdkClient
      .request(searchDiagnosticsV2(deviceId, body, params))
      .pipe(
        map((response: DeviceResourceDiagnosticsListResponseApi) =>
          mapDeviceDiagnosticsResponseApiToPaginatedDeviceDiagnosticsList(response),
        ),
      );
  }

  getCallLogsDetails({ logicalDeviceId, callId }: GetCallLogsDetailsInput): Observable<DeviceCallLogDetail> {
    return this.apiSdkClient.request(getDeviceCallByIdV2(logicalDeviceId, callId)).pipe(
      mergeMap((call) =>
        forkJoin([
          of(call),
          this.apiSdkClient.request(
            searchPhysicalDevicesV1(
              {
                filters: [
                  {
                    filterType: 'string',
                    name: 'physicalDevice.serialNumber',
                    operator: 'equals',
                    value: call.device.serialNumber,
                  },
                ],
                sort: {},
              },
              { offset: 0, limit: 1 },
            ),
          ),
        ]),
      ),
      map(([deviceCallResponse, physicalDeviceResponse]) =>
        mapGetDeviceCallLogsByCallIdV1(deviceCallResponse, physicalDeviceResponse),
      ),
    );
  }

  getSearchDeviceCallStatus({
    body,
    params,
    deviceId,
  }: {
    readonly deviceId: string;
    readonly body: SearchDeviceCallsV2MutationRequestApi;
    readonly params?: SearchDeviceCallsV2QueryParamsApi;
  }): Observable<CallStatusResourceResponseListResponseApi> {
    return this.apiSdkClient
      .request(searchDeviceCallsV2(deviceId, body, params))
      .pipe(map((response) => mapDeviceCallLogsResponseApiToPaginatedDeviceCallLogsList(response)));
  }

  getSearchDeviceCallStatusFront({
    body,
    params,
    deviceId,
  }: {
    deviceId: string;
    body: SearchDeviceCallsV2MutationRequestApi;
    params?: SearchDeviceCallsV2QueryParamsApi;
  }): Observable<DeviceCallLogsResponseApiFront> {
    return this.apiSdkClient
      .request(searchDeviceCallsV2(deviceId, body, params))
      .pipe(map((response) => mapDeviceCallLogsResponseApiToPaginatedDeviceCallLogsListFront(response)));
  }

  /* -------------------------------------------------------------------------- */
  /*                            BLOCK / DEVICE LOGS                             */
  /* -------------------------------------------------------------------------- */

  searchDeviceLogs({
    logicalDeviceId,
    body,
    params,
    isRefetch,
  }: {
    readonly body: SearchDeviceLogV2MutationRequestApi;
    readonly params?: SearchDeviceLogV2QueryParamsApi;
    readonly logicalDeviceId: string;
    readonly isRefetch?: boolean;
  }): Observable<DeviceLogsResponse> {
    return this.apiSdkClient
      .request(searchDeviceLogV2(logicalDeviceId, body, params), { isRefetch })
      .pipe(map(mapSearchDeviceLogsResponse));
  }

  downloadDeviceLogFile(logicalDeviceId: string, logFileId: string): Observable<Blob> {
    return this.apiSdkClient.request(downloadDeviceLogFileByIdV2(logicalDeviceId, logFileId));
  }

  stopRecordingLogs(
    deviceId: string,
    body = {} as CreateStopDeviceLogSessionV2MutationRequestApi,
  ): Observable<unknown> {
    return this.apiSdkClient.request(createStopDeviceLogSessionV2(deviceId, body));
  }

  /* -------------------------------------------------------------------------- */
  /*                            BLOCK / DEVICE LOGS END                         */
  /* -------------------------------------------------------------------------- */

  /* -------------------------------------------------------------------------- */
  /*                          CREATE LOG REQUEST START                          */
  /* -------------------------------------------------------------------------- */

  createLogRequest({
    deviceId,
    body,
  }: {
    readonly deviceId: string;
    readonly body: CreateDeviceLogSessionV2MutationRequestApi;
  }): Observable<unknown> {
    return this.apiSdkClient.request(createDeviceLogSessionV2(deviceId, body));
  }

  createLogRequestFromFormulary(deviceId: string, input: CreateLogRequestFormularySchema): Observable<unknown> {
    return this.createLogRequest({
      deviceId,
      body: fromCreateLogRequestFormularySchemaToCreateDeviceLogSessionV2MutationRequestApi(input),
    });
  }

  cancelLogRequest({ deviceLogId }: { readonly deviceLogId: string }): Observable<unknown> {
    return this.apiSdkClient.request(createCancelDeviceLogSessionV2(deviceLogId, {}));
  }

  /* -------------------------------------------------------------------------- */
  /*                           CREATE LOG REQUEST END                           */
  /* -------------------------------------------------------------------------- */

  getDeviceConnectionStatus({ deviceId }: { readonly deviceId: string }): Observable<DeviceConnectionStatus> {
    return this.apiSdkClient
      .request(getDeviceConnectionStatusByDeviceIdV1(deviceId), { disableCache: true })
      .pipe(map((response) => mapDeviceConnectionStatus(response, deviceId)));
  }

  getSoftwareListByLogicalDeviceId({
    logicalDeviceId,
    isRefetch = false,
  }: {
    readonly logicalDeviceId: string;
    readonly isRefetch?: boolean;
  }): Observable<ApplicationsList> {
    return this.apiSdkClient
      .request(getDeviceSoftwaresByDeviceIdV2(logicalDeviceId), { isRefetch })
      .pipe(map((response) => mapApplicationsList(response)));
  }

  askDeviceUpdate(requestData: AskDeviceUpdateRequest): Observable<unknown> {
    return this.apiSdkClient.request(
      createUpdateActionMetricsByDeviceIdV2(requestData.deviceId, {
        levels: [
          enumMonitoringLevels.APPLICATIONS,
          enumMonitoringLevels.BASIC,
          enumMonitoringLevels.BASIC_REFRESH_LOCATION,
          enumMonitoringLevels.CAPABILITIES,
          enumMonitoringLevels.HARDWARE,
          enumMonitoringLevels.EXPERT,
        ],
      }),
    );
  }

  askMultipleDeviceUpdate(requestData: AskDeviceUpdateRequest[]): Observable<unknown[]> {
    return forkJoin(
      requestData.map((requestPayload) => this.askDeviceUpdate(requestPayload).pipe(catchError(() => of([])))),
    );
  }

  getDeviceAlertsById(logicalDeviceId: string): Observable<DeviceAlerts> {
    return this.apiSdkClient.request(getDeviceAlertsV2(logicalDeviceId)).pipe(map(mapGetDeviceAlertsResponse));
  }

  searchCatalogShares(
    {
      body,
      params,
    }: {
      body: SearchCatalogSharesBffV2MutationRequestApi;
      params?: SearchCatalogSharesBffV2QueryParamsApi;
    },
    isRefetch = false,
  ): Observable<CatalogShareSearchResponse> {
    return this.apiSdkClient
      .request(searchCatalogSharesBffV2(body, params), { isRefetch })
      .pipe(map(mapCatalogSharesResponse));
  }

  createCatalogShare(applicationVersionId: string, emails: string[]): Observable<CatalogShareResourceReadApi> {
    const body = mapCreateCatalogShareRequest({ applicationVersionId, emails });
    return this.apiSdkClient.request(createCatalogShareV2(body));
  }

  revokeCatalogShare(catalogSharedId: string): Observable<CatalogShareResourceReadApi> {
    return this.apiSdkClient.request(triggerCatalogShareRevokeV2(catalogSharedId, {}));
  }

  getArtifactsListForFormBuilder(
    body: SearchResourcesV2MutationRequestApi,
    isRefetch?: boolean,
  ): Observable<ArtifactSimpleResource[]> {
    return this.apiSdkClient
      .request(searchResourcesV2(body, { offset: 0, limit: 30 }), { isRefetch })
      .pipe(map((response) => mapArtifactsListForFormBuilderResponse(response)));
  }

  getArtifactsByIdsForFormBuilder(resourceIds: string[], isRefetch?: boolean): Observable<ArtifactSimpleResource[]> {
    if (resourceIds.length === 0) return of([]);

    const body: SearchResourcesV2MutationRequestApi = {
      filters: [
        {
          filterType: 'array',
          name: 'resource.id',
          operator: 'in',
          value: JSON.stringify(resourceIds),
        },
      ],
      sort: {},
    };

    return this.apiSdkClient
      .requestFullDataOfPaginatedResponse((params) => searchResourcesV2(body, params), { isRefetch })
      .pipe(map((response) => mapArtifactsListForFormBuilderResponse(response)));
  }

  createArtifactForFormBuilder(payload: ArtifactCreationBody): Observable<ArtifactSimpleResource> {
    const fileAsOctetStream = new File([payload.file], payload.file.name, { type: 'application/octet-stream' });
    return this.apiSdkClient
      .request(
        createArtifactV2(fileAsOctetStream, {
          artifactName: payload.file.name,
          artifactType: 'DATA_FILE',
          componentType: 'RESOURCE',
          checksum: payload.checksum,
        }),
      )
      .pipe(
        switchMap((response) =>
          this.apiSdkClient.request(
            createResourceV2({ name: payload.name, description: payload.description, artifactId: response.id }),
          ),
        ),
        map((response) => ({
          id: toString(response.id),
          name: toString(response.name),
          extension: response.artifact?.extension,
        })),
      );
  }

  getDataFileArtifactBlob(resourceId: string): Observable<Blob> {
    return this.apiSdkClient
      .request(getResourceByIdV2(resourceId))
      .pipe(switchMap((resource) => this.apiSdkClient.request(downloadArtifactByIdV2(resource.artifact.id))));
  }

  getResourceDownloadLink(resourceId: string): Observable<string> {
    return this.apiSdkClient
      .request(getResourceDownloadLinkV2(resourceId))
      .pipe(map((response) => toString(response.downloadLink)));
  }

  editResource(resourceId: string, body: UpdateResourceByIdV2MutationRequestApi): Observable<ResourceListItemFront> {
    return this.apiSdkClient.request(updateResourceByIdV2(resourceId, body)).pipe(map(mapEditResourceResponse));
  }

  getDeploymentUnitSearchFieldValues(fieldId: string, isRefetch?: boolean): Observable<string[]> {
    return this.apiSdkClient.request(getDeploymentUnitSearchFieldValuesV2(fieldId), { isRefetch });
  }

  triggerTargetDeploymentRequests({
    targets,
  }: Pick<
    DeploymentRequestResourceTriggerDeviceListV2Api,
    'targets'
  >): Observable<TriggerDeploymentRequestV2MutationResponseApi> {
    return this.apiSdkClient.request(triggerDeploymentRequestV2({ targets }));
  }

  getBffLogicalDeviceList(
    filters: SearchFilterApi[],
    sort: SearchRequestSortApi,
    isRefetch?: boolean,
  ): Observable<BffPaginatedLogicalDeviceList> {
    return this.apiSdkClient
      .request(searchBffLogicalDevicesV1({ filters, sort }), { isRefetch })
      .pipe(
        map((logicalDeviceList) => mapBffLogicalDeviceListResponseApiToPaginatedLogicalDeviceList(logicalDeviceList)),
      );
  }

  blockPhysicalDeviceV1(physicalDeviceId: string): Observable<PhysicalDeviceResourceReadApi> {
    return this.apiSdkClient.request(blockPhysicalDeviceByIdV1(physicalDeviceId));
  }

  unblockPhysicalDeviceV1(physicalDeviceId: string): Observable<PhysicalDeviceResourceReadApi> {
    return this.apiSdkClient.request(unblockPhysicalDeviceByIdV1(physicalDeviceId));
  }

  getAttachmentsList({ logicalDeviceId }: { logicalDeviceId: string }): Observable<MappedAttachmentsResponseApi> {
    return this.apiSdkClient
      .request(getPhysicalDevicesByLogicalDeviceIdV1(logicalDeviceId))
      .pipe(map((response) => mapAttachmentsList(response)));
  }

  getAttachmentStatus(attachmentId: string): Observable<boolean> {
    return this.apiSdkClient
      .request(getSwappableStatusLogicalDeviceV1(attachmentId))
      .pipe(map((status) => mapAttachmentStatus(status)));
  }

  getDeviceChangesById(deviceChangeId: string, isRefetch = false): Observable<DeviceChangeResourceApiByIdV2> {
    return this.apiSdkClient
      .request(getDeploymentUnitByIdBffV2(deviceChangeId), { isRefetch })
      .pipe(map(mapDeviceChangeResourceApi));
  }

  createProfileGroup(body: ProfileGroupBody): Observable<SimpleCreateDeploymentAutomatorResponse> {
    return this.apiSdkClient
      .request(createDeploymentAutomatorV2(mapProfileGroupBodyToCreateDeploymentAutomatorV2MutationRequestApi(body)))
      .pipe(map(mapCreateDeploymentAutomatorResponse));
  }

  getDynamicGroups(
    body: SearchDynamicGroupsBffV1MutationRequestApi,
    params?: SearchDynamicGroupsBffV1QueryParamsApi,
  ): Observable<DynamicGroupListBffResponseApi> {
    return this.apiSdkClient
      .request(searchDynamicGroupsBffV1(body, params))
      .pipe(map((response) => mapDynamicGroupsList(response)));
  }

  deleteAutomatorById(id: string): Observable<unknown> {
    return this.apiSdkClient.request(deleteDeploymentAutomatorByIdV2(id));
  }
}
